// Bulgarian translations (primary language)

const bg = {
  common: {
    appName: 'ArbiWin.bg',
    language: 'Език',
    save: 'Запази',
    cancel: 'Отказ',
    close: 'Затвори',
    confirm: 'Потвърди',
    back: 'Назад',
    next: 'Напред',
    submit: 'Изпрати',
    apply: 'Приложи',
    reset: 'Нулиране',
    clear: 'Изчисти',
    yes: 'Да',
    no: 'Не',
    search: 'Търсене',
    loading: 'Зареждане...',
    required: 'Задължително поле',
  },

  navigation: {
    home: 'Начало',
    login: 'Вход',
    register: 'Регистрация',
    dashboard: 'Табло',
    subscription: 'Абонамент',
    surebets: 'Арбитражи',
    about: 'За нас',
    contact: 'Контакт',
    terms: 'Условия',
    privacy: 'Поверителност',
    profile: 'Профил',
    logout: 'Изход',
    overview: 'Преглед',
    pricing: 'Цени',
    faq: 'Често задавани въпроси',
    howToSubscribe: 'Как да се абонирам',
    loading: 'Зареждане...',
    checkingAuthentication: 'Проверка на автентичност...',
    checkingSubscription: 'Проверка на абонамент...',
    checkingPermissions: 'Проверка на права...',
    breadcrumb: {
      ariaLabel: 'Навигационни трохи',
      navigateTo: 'Отиди до {page}',
      home: 'Начало',
    },
  },

  landing: {
    hero: {
      title: 'Математическо предимство чрез динамичен анализ на данни',
      subtitle: 'ArbiWin.bg е интелигентен терминал за спортни данни. Откривайте арбитражни ситуации (безрискови математически модели) и засичайте пазарни аномалии (най-високите стойности на пазара) сред 23 лицензирани оператора в България. Всичко това – в реално време, директно на Вашия екран или в Telegram.',
      getStarted: 'Започни 3-дневен безплатен тест',
    },
    heroToggle: {
      ariaLabel: 'Превключи между продуктите на платформата',
      arbitrage: '⚖️ АРБИТРАЖНИ СИТУАЦИИ',
      bestOdds: '🚀 ПАЗАРНИ АНОМАЛИИ (Best Odds)',
    },
    previews: {
      title: 'Преглед на Арбитражни Ситуации',
      description: 'Поглед в реално време върху пазарните неефективности, открити от нашия алгоритъм. Детайлите са скрити за потребители без абонамент.',
      tableProfit: 'Марж',
      tableEvent: 'Събитие',
      tableMarket: 'Пазар',
      tableBookmakers: 'Оператори',
      bookmakerCount: 'Operators',
      unlock: 'Виж',
      market1X2: 'Краен резултат (1X2)',
      marketOverUnder: 'Тотал Точки (Над/Под)',
      marketWinner: 'Победител',
      marketHandicap: 'Азиатски Хандикап',
    },
    pricing: {
      title: 'ArbiWin Premium: Пълен аналитичен достъп',
      description: '',
      planTitle: 'ArbiWin Premium',
      period: '(на месец)',
      featuresIncludes: 'Какво включва:',
      feature1: '✅ Модул Арбитражи: Неограничен достъп до всички арбитражни ситуации',
      feature2: '✅ Модул Пазарни Аномалии: Радар за най-високи стойности спрямо средните за пазара (само за Tier 1 лиги)',
      feature3: '✅ Telegram Известия: Автоматични аларми при засичане на изгодни позиции',
      feature4: '✅ Интегриран калкулатор: Оптимизация на капитала при арбитраж',
      feature5: '✅ Динамично опресняване на данните от 23 оператора',
      cta: 'Започни 3-дневен безплатен тест',
      promoText: '🎁 3 Дни Безплатен Пробен Период (Само за нови абонати)',
      promoDisclaimer: '(Таксуване след 3-тия ден. Без обвързване, прекратяваш когато решиш).',
    },
    cta: {
      title: 'Овладей пазарната ефективност с ArbiWin.bg',
      button: 'Създай акаунт',
    },
    testimonials: {
      title: 'Отзиви от потребители',
      subtitle: 'Присъединете се към потребителите, които използват данни за по-умни решения',
      testimonial1: {
        quote: 'ArbiWin.bg промени подхода ми. Вместо да гадая, вече следвам строга математическа стратегия.',
        name: 'Иван Петров',
        role: 'Потребител от 6 месеца'
      },
      testimonial2: {
        quote: 'Платформата е интуитивна и много лесна за използване. Задължителен инструмент.',
        name: 'Мария Георгиева',
        role: 'Потребител от 1 месец'
      },
      testimonial3: {
        quote: 'Отлична възвръщаемост на абонамента. Калкулаторът ми спестява време и минимизира грешките.',
        name: 'Димитър Стоянов',
        role: 'Потребител от 2 месеца'
      },
      trust: {
        users: '500+',
        usersLabel: 'Активни потребители',
        surebets: '10,000+',
        surebetsLabel: 'Намерени възможности',
        satisfaction: '98%',
        satisfactionLabel: 'Ниво на задържане'
      }
    },
    maskedPreview: {
      title: 'Симулация на открити математически несъответствия',
      subtitle: 'Възползвайте се от разликата в стойностите между различните оператори.',
      totalLabel: 'Активни възможности',
      profitableLabel: 'Възможности с висок марж',
      shownLabel: 'Показани (топ по марж)',
      loading: 'Зареждане на пазарни данни...',
      error: 'Грешка при зареждане',
      empty: 'Няма възможности отговарящи на критериите',
      activateButton: 'Активирай абонамент',
      unlockButton: 'Отключи детайли',
      eventColumn: 'Събитие',
      marketColumn: 'Пазар',
      oddsColumn: 'Коефициенти',
      profitColumn: 'Марж',
      actionColumn: 'Действие',
    },
    liveDemo: {
      title: 'LIVE DEMO: Актуална възможност в момента',
      footerLink: 'Виж останалите арбитражни възможности – Абонирай се сега',
      bookmakerLabel: 'Букмейкър',
      marginInfoAriaLabel: 'Информация за Live Demo марж',
      marginInfoTooltip:
        'Този сигнал е част от нашето Live Demo. Данните се предоставят с илюстративна цел и отразяват реалната функционалност на платформата. За пълен достъп до всички анализи, активирайте Premium абонамент.',
    },
    bestOddsPreview: {
      title: 'Радар за пазарни аномалии (Топ Лиги)',
      subtitle: 'Алгоритъмът сканира елитните първенства (Tier 1) и Ви алармира, когато даден оператор предложи стойност, драстично надвишаваща средната за пазара.',
      totalLabel: 'Активни аномалии',
      shownLabel: 'Показани (топ по отклонение)',
      loading: 'Зареждане на пазарни данни...',
      error: 'Грешка при зареждане',
      empty: 'Няма открити пазарни аномалии в момента',
      activateButton: 'Активирай абонамент',
      unlockButton: 'Отключи детайли',
      unlockAllButton: 'Отключи всички',
      newBestOddsBadge: '🚨 НОВА ПАЗАРНА АНОМАЛИЯ',
      eventLabel: 'Събитие',
      marketLabel: 'Пазар',
      outcomeLabel: 'Изход',
      maxValueLabel: 'Максимална стойност',
      marketAvgLabel: 'Средна за пазара',
      spreadLabel: 'Отклонение (Spread)',
      bookmakerHiddenLabel: 'Скрит букмейкър',
      eventHiddenLabel: 'Скрито събитие',
    },
    bestOddsLiveDemo: {
      title: 'LIVE DEMO: Актуална пазарна аномалия',
      footerLink: 'Отключи всички',
      badge: 'LIVE DEMO',
    },
    telegramPromo: {
      title: '🚀 НОВО: Твоят личен алгоритъм вече работи в Telegram',
      subtitle: 'Не губи време пред екрана. Настрой своите филтри и остави ArbiWin да работи за теб 24/7.',
      feature1: {
        title: '🎯 Персонализиран марж',
        description: 'Задай своя минимум (напр. над 3%) и получавай сигнал само когато си заслужава.',
      },
      feature2: {
        title: '🛡️ Смарт Анти-Спам',
        description: 'Вградена 4-часова защита от дублиращи се сигнали за един и същ мач.',
      },
      feature3: {
        title: '🔕 Тихи часове',
        description: 'Активирай режим "Сън" (00:00 – 08:00 ч.), за да не бъдеш безпокоен през нощта.',
      },
      cta: 'Започни 3-дневен безплатен тест',
    },
    academyPromo: {
      title: '🎓 ArbiWin Академия: Учи от реални пазарни данни',
      intro1: 'Искате ли да видите как работи алгоритъмът ни в действие?',
      intro2: 'Последвайте нашия официален YouTube канал @ArbiWin-SportsAnalytics.',
      introLead: 'Там регулярно публикуваме:',
      feature1: '✔️ Case Studies (Казуси): Разбор на реални арбитражни ситуации и пазарни аномалии, засечени от софтуера.',
      feature2: '✔️ Ръководства: Как да използвате филтрите, калкулатора и смарт известията в Telegram за максимална ефективност.',
      feature3: '✔️ Математически стратегии: Обяснение на логиката зад движенията на коефициентите при лицензираните оператори.',
      cta: 'Абонирай се в YouTube',
      disclaimer: '*Важно: Всички размаскирани данни, имена на оператори и коефициенти, показани във видео материалите, са със задна дата (архивни) и служат изцяло за образователни и илюстративни цели. ArbiWin.bg не предоставя хазартни консултации. За актуален мониторинг в реално време е необходим активен абонамент.',
    },
    educational: {
      expand: 'Виж още',
      collapse: 'Свий',
      whatIsSurebet: {
        title: 'Какво е спортен арбитраж?',
        intro: 'Нашият алгоритъм засича разлики, които позволяват покриването на всички изходи от дадено събитие.',
        visual: {
          title: 'Механизъм на арбитража',
          bookmaker1: 'Оператор А',
          bookmaker2: 'Оператор Б',
          outcome1: 'Изход 1',
          outcome2: 'Изход 2',
          profit: 'Положителен марж'
        },
        point1: {
          title: 'Математическа стратегия',
          description: 'Чрез покриване на всички изходи, стратегията разчита на математика, а не на прогнози или късмет.'
        },
        point2: {
          title: 'Използване на неефективности',
          description: 'Операторите често оценяват събитията различно. Ние идентифицираме тези пропуски.'
        },
        point3: {
          title: 'Интелигентно изчисление',
          description: 'Нашите инструменти изчисляват точното разпределение, необходимо за балансирана позиция.'
        },
        example: {
          title: 'Математиката зад процеса',
          scenario: 'Пример: Събитие с 2.5% арбитражен марж при използване на 1000 единици.',
          step1: 'Разпределение: 490 единици на Изход 1 (Коеф. 2.10)',
          step2: 'Разпределение: 510 единици на Изход 2 (Коеф. 2.15)',
          step3: 'Резултат: 1025 единици възвръщаемост, независимо от победителя.',
          result: 'Нетен положителен резултат'
        }
      },
      whatIsMarketAnomaly: {
        title: 'Какво е Пазарна Аномалия?',
        intro: 'Докато спортният арбитраж разчита на покриване на всички възможни изходи от едно събитие за гарантирана възвръщаемост, Пазарната аномалия (Value Betting / Best Odds) е стратегия, фокусирана върху намирането на математическа грешка в оценката на само един конкретен изход.',
        algorithm: {
          title: 'Как работи алгоритъмът на ArbiWin?',
          scan: 'Нашата система непрекъснато сканира и осреднява стойностите, предлагани от всички 23 лицензирани оператора в България за даден изход (например: Победа за Домакин).',
          detection: 'Когато алгоритъмът засече, че един оператор предлага коефициент, който се отклонява значително (например с 10% или повече) над средната пазарна стойност (Market Average), системата маркира това като Аномалия.',
        },
        example: {
          title: 'Пример от практиката:',
          marketAverage: 'Среден коефициент на пазара за "Победа на Арсенал":',
          marketAverageValue: '2.04',
          operatorCoefficient: 'Коефициент в Оператор А:',
          operatorCoefficientValue: '2.12',
          spread: 'Отклонение (Spread):',
          spreadValue: '+3.92%',
          conclusion: 'Това означава, че Оператор А е подценил събитието или е забавил актуализацията на данните си. Използването на такива "аномалии" дава на информирания потребител дългосрочно математическо предимство (Expected Value) над пазара.',
        },
        warning: {
          label: 'Важно:',
          text: 'За разлика от арбитража, при пазарните аномалии не се покриват всички изходи. Резултатът от всяко отделно събитие остава неизвестен, но системното използване на такива завишени стойности е в основата на професионалния статистически анализ.',
        },
      },
      bookmakerLimitations: {
        title: 'Устойчивост на акаунта и добри практики',
        intro: 'За да поддържате акаунтите си в добро състояние, докато търгувате на спортните пазари, помислете за следните практики:',
        tip1: {
          title: 'Диверсификация на платформи',
          description: 'Разпределете активността си между множество лицензирани оператори.'
        },
        tip2: {
          title: 'Кръгли суми',
          description: 'Използвайте кръгли суми, за да имитирате развлекателно поведение (напр. 50 вместо 49.32).'
        },
        tip3: {
          title: 'Смесена стратегия',
          description: 'Не разчитайте единствено на арбитраж. Естественият профил включва различни видове активност.'
        },
        tip4: {
          title: 'Използвайте ArbiWin Интелект',
          description: 'Ние агрегираме данни от много източници, за да ви помогнем да разпределите обема си.'
        },
        strategy: {
          title: 'Стратегия за устойчивост',
          step1: {
            title: 'Множество регистрации',
            description: 'Наличието на акаунти във всички големи лицензирани оператори е от съществено значение за арбитража.'
          },
          step2: {
            title: 'Смесване на активността',
            description: 'Използвайте платформата ни, за да намирате възможности, които не изглеждат подозрителни.'
          },
          step3: {
            title: 'Бъдете естествени',
            description: 'Избягвайте модели, типични за ботове или агресивни търговци, за да удължите живота на акаунта.'
          }
        }
      },
      whyUnique: {
        title: 'Защо ArbiWin.bg?',
        intro: 'Специализирани анализи за българския пазар, предлагащи отчетливи предимства:',
        feature1: {
          title: '100% Фокус върху България',
          description: 'Следим само лицензирани български оператори, гарантирайки релевантност и безопасност за местните потребители.'
        },
        feature2: {
          title: 'Поток от данни',
          description: 'Обновяване на данните периодично за улавяне на пазарните възможности.'
        },
        feature3: {
          title: 'Интегриран калкулатор',
          description: 'Мигновено изчислява оптималното разпределение на сумите за всеки даден марж.'
        },
        feature4: {
          title: 'Умни филтри',
          description: 'Филтриране по ROI, конкретен оператор, спорт и време до началото.'
        },
        feature5: {
          title: '🤖 Пълна Telegram Автоматизация:',
          description: 'За разлика от стандартните платформи, които изискват да стоите с часове пред екрана и да рефрешвате ръчно, ArbiWin работи като Ваш личен асистент. Вие задавате своите параметри за минимален марж, а софтуерът Ви изпраща мигновено известие в Telegram в секундата, в която засече пазарна неефективност. Вие инвестирате време само тогава, когато има реална възможност за действие.'
        },
        feature6: {
          title: '🧠 Изкуствен интелект срещу спам (Zero-Spam Logic)',
          description: 'Нашият Telegram бот не Ви залива с безсмислени съобщения. Алгоритъмът ни за Пазарни Аномалии използва глобален филтър – получавате известие само когато стойността реално се подобри (достигне нов пазарен връх). Ако пазарът е в застой, телефонът Ви остава тих, а Вие запазвате фокус.'
        },
        comparison: {
          title: 'Сравнение на платформи',
          other: {
            title: 'Общи платформи',
            point1: 'Претрупани с нерелевантни чужди оператори',
            point2: 'Скъпи абонаменти',
            point3: 'Сложни за начинаещи'
          },
          our: {
            title: 'ArbiWin.bg',
            point1: 'Създаден за България',
            point2: 'Поддържа само лицензирани оператори',
            point3: 'Изпращане на нотификации над определен марж'
          }
        }
      },
      bestOddsFaq: {
        title: 'Арбитражни ситуации vs Пазарни аномалии',
        q1: {
          question: 'Каква е разликата между Арбитражни ситуации и Пазарни аномалии (Best Odds)?',
          answer: 'Арбитражът е математическа ситуация, при която чрез покриване на всички възможни изходи на дадено събитие в различни оператори си осигурявате очаквана възвръщаемост, независимо от крайния резултат. Пазарните аномалии (Best Odds) показват единични стойности (коефициенти) за конкретен изход, които алгоритъмът ни е определил като значително по-високи от средните за останалите оператори. При пазарните аномалии Вие избирате да анализирате само един конкретен изход.',
        },
        q2: {
          question: 'Защо в "Пазарни аномалии" виждам само мачове от големите първенства?',
          answer: 'Модулът за пазарни аномалии е настроен да сканира само т.нар. Tier 1 лиги (елитните европейски турнири като Шампионска лига, Висша лига на Англия, Ла Лига и др.). Това гарантира висока ликвидност при операторите и минимизира риска от технически грешки при формирането на коефициентите (т.нар. „палци“), които често се срещат в по-ниските дивизии.',
        },
      },
      telegramNotifications: {
        title: 'Telegram известия и Настройки',
        q1: {
          question: 'Как да свържа и активирам своя Telegram бот?',
          intro: 'Активацията отнема точно 10 секунди:',
          step1: 'Влезте в своя профил на ArbiWin.bg и отворете секция „Профил“.',
          step2: 'В панела „Нотификационен център“, натиснете бутона „Свържи с Telegram“.',
          step3: 'С кликване ще се отвори Telegram. Натиснете бутона START и ботът ще потвърди свързването незабавно! (Услугата е безплатна и достъпна за всички потребители с активен Premium абонамент или 3-дневен пробен период).',
        },
        q2: {
          question: 'Защо виждам арбитраж или аномалия в сайта, но не получих известие в Telegram?',
          intro: 'Нашият алгоритъм използва многослойна защита от спам, за да Ви изпраща само най-важната информация. Възможно е да не сте получили известие поради една от следните причини:',
          reason1: 'Вашият личен филтър: Процентът (марж или отклонение) на събитието е по-нисък от зададения от Вас праг в настройките.',
          reason2: 'Режим „Тихи часове“: Известията Ви са спрени в диапазона 00:00–08:00 ч.',
          reason3: 'Правилото за „Нов Връх“ (Само за Пазарни аномалии): Системата ни изпраща известие само когато коефициентът се покачи и отбележи нова най-висока стойност на пазара. Ако операторът задържи същия висок коефициент с часове или леко го понижи, Вие ще продължите да го виждате в сайта, но ботът няма да Ви спами повторно за него.',
          reason4: 'Смарт Анти-Спам (4 часа): Вече сте получили сигнал за това конкретно събитие (при арбитражите) или за този конкретен изход (при аномалиите) в последните 4 часа. Системата временно заглушава повтарящите се сигнали, за да можете да се фокусирате върху новите възможности.',
        },
      },
      interactiveExamples: {
        title: 'Сценарии',
        intro: 'Практически примери как работят маржовете:',
        scenario1: {
          title: 'Пример: Малък обем',
          description: 'Общ обем 100 единици с 2.5% марж.',
          calc1: 'Обем: 100',
          calc2: 'Възвръщаемост: 102.50',
          calc3: 'Нетно: +2.50'
        },
        scenario2: {
          title: 'Пример: По-голям обем',
          description: 'Общ обем 500 единици с 2.5% марж.',
          calc1: 'Обем: 500',
          calc2: 'Възвръщаемост: 512.50',
          calc3: 'Нетно: +12.50'
        },
        cta: 'Включи се за още'
      }
    },
  },

  dashboard: {
    tabs: {
      arbitrage: '📊 Арбитражен Анализ',
      bestOdds: '🔥 Пазарни Аномалии',
      nearArb: 'Near-arb',
      notifications: '🔔 Известия (Telegram)',
    },
    productInfo: {
      arbitrage: 'Този модул предоставя класически арбитражен анализ с положителен марж. Сигналите са подредени по най-висок марж.',
      bestOdds: 'Този модул сканира елитните турнири (Tier 1). Картите се появяват динамично, когато алгоритъмът засече отклонение (Spread) над зададения праг спрямо средната пазарна стойност.',
      nearArb: 'Показва събития над зададения праг за конфигурираните букмейкъри, включително положителен марж. Стойност 0% или по-ниска не е сигурен залог. Коефициентите в обектите се различават от тези в онлайн сайтовете на букмейкърите.',
    },
  },

  nearArb: {
    infoLine: 'Букмейкъри: {bookmakers}. Праг: над {minMargin}%',
    upgradeRequired: 'Необходим е Ultimate абонамент',
    unavailable: 'Near-arb не е наличен',
  },

  admin: {
    activity: {
      title: 'Продуктова активност',
      subtitle: 'Вътрешна статистика за ползване на платформата (само Super Admin).',
      from: 'От',
      to: 'До',
      refresh: 'Обнови',
      loading: 'Зареждане...',
      rangeHint: 'Максимален период: {max} дни. Без автоматично обновяване.',
      totalsTitle: 'Общо по действие',
      byDayTitle: 'По дни',
      empty: 'Няма данни за избрания период.',
      columns: {
        action: 'Действие',
        count: 'Брой',
        uniqueUsers: 'Уникални потребители',
        date: 'Дата'
      },
      errors: {
        forbidden: 'Нямате права за достъп до тази статистика.',
        unauthorized: 'Сесията е изтекла. Моля влезте отново.',
        rateLimited: 'Твърде много заявки. Опитайте отново след малко.',
        rangeTooLarge: 'Периодът не може да надвишава {max} дни.',
        fromAfterTo: 'Началната дата трябва да е преди или равна на крайната.',
        invalidRange: 'Моля изберете валиден период.',
        badRequest: 'Невалидна заявка.',
        unknown: 'Възникна грешка при зареждане на статистиката.'
      }
    }
  },

  dataAnalytics: {
    seo: {
      title: 'ArbiWin | Аналитичен Софтуер за Пазарни Данни и Статистика',
      description: 'Професионална SaaS платформа за сравнителен статистически анализ на пазарни данни в реално време. Автоматизирано индексиране на 22 независими източника.',
    },
    hero: {
      title: 'Математическо предимство чрез динамичен анализ на данни',
      subtitle: 'ArbiWin е разпределена софтуерна система за мониторинг на пазарни неефективности. Сравнявайте и анализирайте математически стойности от 23 независими цифрови платформи в България',
      cta: 'Отвори Аналитичния Терминал',
    },
    tech: {
      title: 'Какво е статистическа неефективност?',
      text: 'Във всяка динамична система от данни възникват пазарни несъответствия. Когато Източник А и Източник Б предоставят различни математически стойности за едно и също събитие, нашият алгоритъм моментално изчислява разликата (маржа). Софтуерът на ArbiWin елиминира ръчното търсене, като Ви предоставя чисти математически факти за вземане на информирани решения.',
    },
    matrix: {
      title: 'Симулация на открита неефективност',
      subtitle: 'Пример за системно несъответствие, отчетено от нашия скенер:',
      eventColumn: 'СЪБИТИЕ',
      marketColumn: 'ПАЗАР',
      nodesColumn: 'ИНФОРМАЦИОННИ ВЪЗЛИ',
      marginColumn: 'МАРЖ',
      actionColumn: 'ДЕЙСТВИЕ',
      eventLabel: 'СЪБИТИЕ #{id} (Клас А)',
      nodeLabel: 'Източник_{n} (Позиция {pos})',
      calculator: 'Калкулатор',
      loading: 'Зареждане на данни...',
      error: 'Данните временно не са достъпни',
      empty: 'Няма открити несъответствия в момента',
    },
    market: {
      margin1X2: 'Краен изход (3-Way)',
      marginOverUnder2AndHalf: 'Праг 2.5 (Бинарен)',
      marginOverUnder1AndHalf: 'Праг 1.5 (Бинарен)',
      marginOverUnder3AndHalf: 'Праг 3.5 (Бинарен)',
      marginBothScore: 'Двоен възел (Yes/No)',
      margin1Xvs2: '1X срещу 2',
      marginX2vs1: 'X2 срещу 1',
      margin12vsX: '12 срещу X',
      default: 'Аналитичен пазар',
    },
    features: {
      title: 'Предимства на платформата',
      card1: {
        title: 'Високоскоростно сканиране',
        text: 'Нашият алгоритъм извършва динамичен мониторинг на 22 български платформи за данни, обработвайки хиляди заявки.',
      },
      card2: {
        title: 'Прецизна филтрация',
        text: 'Настройте филтрите на софтуера така, че да виждате само статистическите показатели и резултатите, които отговарят на Вашия личен модел на анализ.',
      },
      card3: {
        title: 'Липса на субективизъм',
        text: 'Премахнете емоцията от процеса. ArbiWin Ви предоставя чиста математика и статистика, съвместими с Вашите аналитични стратегии.',
      },
    },
    bridge: {
      title: 'Искате ли да отключите реалните източници на данни?',
      text: 'В тази демонстрация имената на източниците на данни са скрити. Преминете към нашия официален аналитичен панел, за да демаскирате всички 22 платформи, да използвате разширените филтри и да стартирате своя безплатен 3-дневен пробен период.',
      cta: 'ОТКЛЮЧИ ПЪЛНИЯ ПАНЕЛ СЕГА',
    },
  },

  promoBanner: {
    title: '🎉 Стартирай своя 3-Дневен Безплатен Тест! (Само за нови абонати)',
    text: 'Отключете всички размаскирани арбитражни ситуации и пазарни аномалии веднага и активирайте новия ни интелигентен Telegram бот. Вече не е нужно да стоите пред екрана – настройте своите филтри и получавайте нотификации директно на телефона си! Тествайте пълния капацитет на платформата абсолютно безплатно.',
    cta: 'Започни БЕЗПЛАТНО',
    disclaimer: '*След изтичане на 3-дневния пробен период, абонаментът се подновява автоматично на стандартна цена от €17.99/месец. Можете да отмените по всяко време преди това, за да не бъдете таксувани.',
    dismiss: 'Затвори',
  },

  telegramDashboardBanner: {
    title: '🤖 Имате активен абонамент, но все още следите пазара ръчно?',
    text: 'Свържете своя безплатен Telegram бот за 10 секунди! Настройте личните си филтри и получавайте мигновени сигнали за високи маржове и пазарни аномалии директно на телефона си, без да стоите пред екрана.',
    cta: 'Кликни тук и активирай от меню „Профил“',
    dismiss: 'Затвори',
  },

  static: {
    nav: {
      terms: 'Общи условия',
      privacy: 'Поверителност',
      contact: 'Контакт',
      about: 'За нас',
      subscribe: 'Как да се абонирам'
    },
    terms: {
      title: 'Общи условия',
      description: 'Общи условия за ползване на ArbiWin.bg',
      companyInfo: 'Доставени от: „ВИ ВИ ЕС ВИ ТЕХ“ ЕООД\nСедалище и адрес на управление: гр. София, ул. Светла, 10\nЗа правни въпроси, защита на личните данни и упражняване на Вашите права: legal@arbiwin.bg.\nЗа общи въпроси и техническа поддръжка, можете да се свържете с нас и на: support@arbiwin.bg.\nЕИК 208695805',
      section1: {
        title: '1. Приемане на условията',
        content: 'Настоящите Общи условия („Условия“) уреждат използването на уебсайта и услугите, предоставяни от „ВИ ВИ ЕС ВИ ТЕХ“ ЕООД („ArbiWin.bg“, „Платформата“, „ние“, „наш“, „нас“).\n\nКато достъпвате или използвате платформата, Вие декларирате и гарантирате, че:\n\nНавършили сте 18 години; и\nЗаконно е във Вашата юрисдикция да преглеждате съдържание, свързано със спортни анализи и статистика.\n\nНие не извършваме активна проверка на самоличност или възраст. Достъпът е изцяло на собствена отговорност на потребителя. Ако не сте съгласни с тези Условия, преустановете използването на платформата незабавно.'
      },
      section2: {
        title: '2. Характер на услугата и източници на информация',
        content: '2.1 Информационна услуга\n\nArbiWin.bg е специализирана информационна платформа, която предоставя:\n\nАвтоматизирани арбитражни сигнали (маскирани за безплатни потребители и размаскирани за абонати);\nМониторинг на пазарни аномалии (Best Odds): Софтуерен инструмент, който агрегира коефициенти от различни източници за елитни спортни лиги (Tier 1) и идентифицира стойности, които се отклоняват значително от средните за пазара (Spread);\nСистема за автоматизирани известия (чрез Telegram) при засичане на зададени от потребителя параметри;\nОграничен брой размаскирани сигнали (LIVE DEMO), достъпни за нерегистрирани потребители или потребители без активен абонамент. Тези сигнали служат единствено за илюстрация на функционалността на софтуера и интерфейса на ArbiWin.bg;\nОбразователно съдържание и статистически анализи;\nПотенциални бъдещи AI-базирани прогнози;\nСпециализирани аналитични модули (напр. Near-Arb): Достъпни за по-високи абонаментни планове (Ultimate), които проследяват специфични пазарни съотношения – включително такива с минимален отрицателен марж – използвайки информационни потоци от физически (наземни) пунктове на избрани оператори, по заявка на клиента за целите на дълбочинен пазарен анализ.\n\n2.2 Агрегиране на данни и независимост\n\nArbiWin.bg действа като независим агрегатор на публично достъпна информация. Платформата индексира, обработва и визуализира фактически данни (числови коефициенти и статистика), които са свободни за преглед в интернет пространството, с цел предоставяне на сравнителен пазарен анализ на своите потребители.\n\nПотребителят се уведомява изрично, че:\n\nArbiWin.bg не е свързан с, не е одобрен от, не е партньор на и не е в договорни отношения с никой от букмейкърите или организаторите на хазартни игри, чиито данни могат да бъдат анализирани на платформата.\n\nКоефициентите представляват фактически данни към момента на тяхното извличане и са обект на постоянна промяна. ArbiWin.bg не генерира тези коефициенти, а само ги отразява с информационна цел.\n\n2.3 Липса на хазартна дейност\n\nArbiWin.bg НЕ е букмейкър, не организира хазартни игри, не приема залози, не обработва плащания за залози и не посредничи пряко при залагане. Платформата не предоставя директни хипервръзки (affiliate links) към букмейкъри към момента на стартиране на услугата.\n\n2.4 Система за известия (Нотификационен център)\n\nКато част от платения абонамент, ArbiWin.bg може да предостави функционалност за получаване на автоматични известия (напр. чрез Telegram) при засичане на пазарни неефективности (арбитраж) или пазарни аномалии (Best Odds) над определен от потребителя праг.\n\nТази функция се предоставя като допълнително удобство. ArbiWin.bg не гарантира доставката на всички известия, нито времето за тяхното получаване, тъй като процесът зависи от инфраструктурата на трети страни (напр. Telegram).\n\nПотребителят разбира, че пазарните данни са силно динамични. Напълно възможно е при получаване на известието, коефициентите при първоизточника вече да са променени. ArbiWin.bg не носи отговорност за пропуснати възможности или финансови резултати вследствие на забавени или неточни известия, както и в случаите, когато потребителят е активирал рестриктивни филтри, режим „Тихи часове“ или се прилагат системни анти-спам ограничения.\n\n2.5 Мониторинг за подобряване на услугата\n\nС цел оптимизация на софтуера и подобряване на потребителското преживяване, ArbiWin.bg има право да събира и анализира вътрешни системни данни (first-party data) за това как потребителят взаимодейства с различните модули и функционалности на платформата. Тази информация се използва изключително за вътрешни цели и се обработва в строго съответствие с нашата Политика за поверителност.'
      },
      section3: {
        title: '3. Липса на професионален съвет',
        content: 'Цялата информация се предоставя само за информационни и развлекателни цели, на база „както е“ и „както е налична“.\n\nНие не гарантираме точност, коректност, наличност, актуалност или рентабилност на който и да е сигнал, прогноза или информация. Спортните анализи и арбитражните ситуации са теоретични математически модели. Потребителите носят единствена отговорност за своите финансови решения и действия.'
      },
      section4: {
        title: '4. Акаунти и регистрация',
        content: 'За достъп до пълната функционалност потребителите трябва да създадат акаунт, като предоставят:\n\nПълно име;\nИмейл адрес;\nПарола.\n\nВие носите отговорност за запазването на конфиденциалността на Вашите идентификационни данни.\n\nОграничение за уникална сесия\n\nВашият абонамент е строго личен и некомерсиален. Позволена е само една активна сесия на акаунт в даден момент. Стартирането на нова сесия автоматично прекратява предишната. Създаването на множество акаунти от едно лице, споделянето на акаунт и препродажбата на достъп са строго забранени и водят до незабавно блокиране без възстановяване на средства.'
      },
      section5: {
        title: '5. Абонамент и плащания',
        content: '5.1 Модел на абонаменти и планове\n\nДостъпът до размаскирани арбитражни сигнали и пълна функционалност изисква активен платен абонамент. ArbiWin.bg предлага различни нива на абонамент (напр. Premium, Ultimate), които осигуряват различен обхват от аналитични инструменти. Актуалните цени и включените услуги за всеки план се обявяват на Платформата или се договарят индивидуално с клиента.\n\n5.2 Обработка на плащания\n\nПлащанията се обработват чрез лицензиран доставчик на платежни услуги – Stripe. ArbiWin.bg не съхранява и няма достъп до пълните данни на Вашата банкова карта.\n\n5.3 Автоматично подновяване и отмяна\n\nАбонаментите се подновяват автоматично всеки месец до момента на тяхната отмяна от страна на потребителя. Можете да отмените абонамента си по всяко време през настройките на профила. При заявяване на отказ/отмяна на абонамента, достъпът на потребителя до размаскираните арбитражни сигнали и пълната функционалност на платформата се прекратява автоматично и незабавно.\n\n5.4 Право на отказ (Digital Content Waiver)\n\nС завършването на поръчката Вие изисквате незабавен достъп до цифровото съдържание и изрично се съгласявате, че:\n\nГубите правото си на отказ от договора в рамките на 14 дни (съгласно чл. 57, т. 13 от ЗЗП и Директива 2011/83/ЕС), след като достъпът до услугата бъде предоставен.\n\n5.5 Възстановяване на суми\n\nСуми се възстановяват само когато е изисквано по закон (напр. пълна техническа невъзможност за достъп до услугата по вина на ArbiWin.bg). Доброволни възстановявания са по наше усмотрение.\n\n5.6 Промоционални кампании и кодове за отстъпка\n\nArbiWin.bg може периодично да предоставя промоционални кодове, които дават право на намалена цена за първия месец (или друг специфичен период) от абонамента.\n\nПри използване на валиден промо код, потребителят ще бъде таксуван с намалената сума само за посочения промоционален период.\n\nСлед изтичане на промоционалния период, абонаментът автоматично се подновява на стандартната месечна цена (без отстъпка), освен ако не бъде прекратен от потребителя преди датата на подновяване.\n\nПромо кодовете са за еднократна употреба на потребител и не могат да се комбинират с други оферти.\n\n5.7 Безплатен пробен период (Free Trial)\n\nПлатформата може да предлага безплатен пробен период (напр. 3 дни) за нови потребители.\n\nЗа активиране на пробния период се изисква въвеждане на валидни данни на платежна карта. По време на пробния период картата няма да бъде таксувана (възможно е само временно блокиране на минимална сума от €0.00 до €1.00 с цел верификация на картата, която се възстановява незабавно).\n\nАко потребителят не отмени абонамента си преди изтичането на пробния период, абонаментът се превръща автоматично в платен и картата ще бъде таксувана със стандартната месечна такса за следващия отчетен период.\n\nПотребителят може да отмени абонамента си по всяко време по време на пробния период чрез настройките на своя профил, при което няма да бъдат начислени никакви такси.\n\n5.8 Промяна на абонаментен план (Upgrade/Downgrade)\n\nПотребителите могат да преминат към по-висок абонаментен план (напр. от Premium към Ultimate). При ръчно или автоматично преминаване към по-висок план, таксуването се извършва съгласно условията на новия план, като евентуални надвзети суми от предходния план се приспадат пропорционално (proration) чрез платежния оператор.'
      },
      section6: {
        title: '6. Приемливо използване',
        content: 'Потребителят се задължава да НЕ:\n\nКопира, извлича (scrape), извършва обратно инженерство или автоматизира достъпа до нашите данни чрез ботове или скриптове;\nЗаобикаля технически ограничения или защита на платформата;\nИзползва платформата за търговски цели или препродажба на данни;\nИзползва услугата в юрисдикция, където достъпът до такова съдържание е забранен.\n\nЗапазваме си правото да блокираме достъпа незабавно при установяване на злоупотреба.'
      },
      section7: {
        title: '7. Без гаранции и ограничение на отговорността',
        content: 'В максималната степен, разрешена от приложимото законодателство, ArbiWin.bg не гарантира, че предоставените коефициенти са актуални към момента на преглед от потребителя.\n\nДанните, предоставяни в модула за „Пазарни аномалии“, имат изцяло аналитичен характер. ArbiWin.bg не гарантира, че залагането на максимални коефициенти (Value betting) ще доведе до финансова печалба, тъй като резултатите зависят от случайни спортни събития.\n\nПотребителят изрично се уведомява и приема, че:\n\nДанните се обновяват периодично (на интервали), а не в реално време;\nКоефициентите при първоизточника (букмейкъра) се променят динамично и е възможно да се различават от визуализираните в платформата в периода между две обновявания;\nArbiWin.bg не носи отговорност за несъответствия между показания коефициент и реалния коефициент към момента на залагане;\nСигналите за пазарни аномалии (Best Odds / ArbiWin Value) показват статистическо отклонение на един коефициент спрямо пазарната средна стойност и НЕ гарантират печалба, нито че коефициентът ще остане наличен при оператора. Модулът е ограничен до избрани Tier 1 (елитни) първенства с цел по-високо качество на данните. Потребителят носи пълна отговорност за самостоятелна проверка на коефициентите преди всяко действие;\nРазмаскираните демо сигнали (LIVE DEMO), достъпни без абонамент, се предоставят на база „както е“ (as is) единствено с илюстративна цел. ArbiWin.bg не носи отговорност за финансови решения или загуби, произтекли от използването на демо данни. Потребителят приема, че демо сигналът може да е с по-висока латентност (забавяне) спрямо сигналите, налични в платения абонамент;\nСпецифични модули като "Near-Arb" умишлено визуализират ситуации с отрицателен математически марж. Потребителят изрично разбира и се съгласява, че използването на тези данни за реални транзакции води до теоретична математическа загуба. ArbiWin.bg предоставя тези данни единствено за статистически цели и не носи отговорност за финансовите резултати на потребителя, нито гарантира получаването на каквито и да е външни бонуси, кешбек или комисионни от трети страни (оператори);\nЗа модулите, използващи данни от физически (наземни) пунктове: ArbiWin.bg не носи никаква отговорност за забавяния при физическото позициониране на пазара (офлайн изпълнение). Потребителят разбира, че локалните коефициенти на каса могат да бъдат променени в реално време от оператора, че служители в пунктовете могат да откажат приемането на заявка или да наложат лимити, както и че приложимите държавни данъци и такси за наземни обекти не са калкулирани в софтуера.\n\nНие не носим отговорност за:\n\nФинансови загуби, пропуснати ползи или щети, възникнали вследствие на използването на предоставената информация;\nНевъзможност за реализиране на арбитраж поради лимитиране на акаунти от трети страни (букмейкъри), промяна на коефициенти или отмяна на залози от букмейкъри.\n\nНашата отговорност, ако не може да бъде напълно изключена, е ограничена до размера на сумата, платена за последния месечен абонамент. За потребители, ползващи единствено безплатни или демо услуги, ArbiWin.bg не носи финансова отговорност.'
      },
      section8: {
        title: '8. Промени в услугата',
        content: 'Можем да модифицираме функциите, обхвата на наблюдаваните пазари, източниците на информация или функционалността на платформата по всяко време с цел подобряване на услугата.'
      },
      section9: {
        title: '9. Прекратяване',
        content: 'Потребителите могат да затворят акаунтите си по всяко време. Ние можем да прекратим достъпа при нарушаване на тези Условия, измама или опити за нерегламентирано споделяне на достъп.'
      },
      section10: {
        title: '10. Интелектуална собственост и Търговски марки',
        content: '10.1 Собственост на ArbiWin.bg\n\nЦялото съдържание, дизайн, софтуерен код, алгоритми, компилации от данни и анализи на платформата са изключителна интелектуална собственост на „ВИ ВИ ЕС ВИ ТЕХ“ ЕООД.\n\n10.2 Търговски марки на трети страни\n\nВсички търговски марки, имена на компании (като Bet365, Efbet, Winbet и др.) и лога, които могат да бъдат споменати текстово на платформата, са собственост на съответните им притежатели.\n\nИзползването на тези имена от страна на ArbiWin.bg е единствено с цел идентификация на източника на фактическата информация (nominative fair use) и за улеснение на потребителя при извършване на сравнителен анализ. ArbiWin.bg не претендира за права върху тези търговски марки и употребата им не означава обвързаност, спонсорство или одобрение от страна на притежателите на марките.'
      },
      section11: {
        title: '11. Бисквитки',
        content: 'Използваме строго необходими бисквитки за автентикация, сигурност и управление на сесиите. Може да използваме аналитични и маркетингови бисквитки (напр. Google Analytics, Meta Pixel) само с вашето съгласие, което можете да дадете или оттеглите чрез банера за съгласие за бисквитки. Можете да промените избора си по всяко време; вижте Политиката ни за поверителност за подробности.'
      },
      section12: {
        title: '12. Защита на данните',
        content: 'Личните данни се обработват съгласно нашата Политика за поверителност и в съответствие с GDPR. Данните се съхраняват на сървъри в Европейското икономическо пространство (Azure North Europe, Ирландия).'
      },
      section13: {
        title: '13. Приложимо право и юрисдикция',
        content: 'Настоящите Условия се регулират от действащото законодателство на Република България. Всички спорове се отнасят към компетентните съдилища в гр. София.'
      },
      section14: {
        title: '14. Език',
        content: 'Тези Условия се предоставят на български и английски език. В случай на несъответствие, предимство има версията на български език.\n\nПоследна актуализация: 06.10.2026'
      }
    },
    privacy: {
      title: 'Политика за поверителност',
      description: 'Политика за поверителност и защита на данните на ArbiWin.bg',
      companyInfo: 'Администратор: „ВИ ВИ ЕС ВИ ТЕХ“ ЕООД\nРегистриран адрес: гр. София, ул. Светла 10\nЗа правни въпроси, защита на личните данни и упражняване на Вашите права: legal@arbiwin.bg.\nЗа общи въпроси и техническа поддръжка, можете да се свържете с нас и на: support@arbiwin.bg.\nЕИК 208695805\n\nПоследна актуализация: 27.07.2026',
      section1: {
        title: '1. Въведение',
        content: 'Тази Политика за поверителност обяснява как „ВИ ВИ ЕС ВИ ТЕХ“ ЕООД ("ArbiWin.bg", "ние", "нас") събира, използва, съхранява и защитава лични данни, когато използвате нашия уебсайт и услуги.\n\nОбработваме лични данни в съответствие с Общия регламент за защита на данните на ЕС (GDPR) и приложимото българско законодателство.'
      },
      section2: {
        title: '2. Лични данни, които събираме',
        content: 'Събираме и обработваме само данните, необходими за работа на услугата.\n\n2.1 Данни, които предоставяте директно\n\nПри създаване на акаунт:\n\n• Пълно име;\n• Имейл адрес;\n• Парола (съхранява се в криптиран вид).\n\nПо избор: всяка комуникация, която ни изпращате чрез имейл.\n\n• Идентификатори за външни приложения: Ако изберете да свържете профила си с външни платформи за нотификации (напр. Telegram), ние ще съхраним Вашия уникален идентификатор (User ID) за съответната платформа, за да можем да Ви изпращаме заявените известия.\n\n2.2 Автоматично събрани данни\n\nПри използване на нашата платформа, ние събираме определени данни автоматично. Те се разделят на три категории:\n\nА) Задължителни технически данни (Не изискват съгласие)\nСъбираме технически данни, които са абсолютно необходими за осигуряване на сигурен достъп, правилно функциониране на платформата и предотвратяване на злоупотреби (като споделяне на акаунти). Те включват:\n• Идентификатори на сесии;\n• Време на влизане;\n• Метаданни за устройство или браузър (User-Agent), достатъчни за прилагане на нашето ограничение за една активна сесия;\n• Основни сървърни логове (IP адрес, време на заявка).\n\nБ) Данни за продуктова активност / Системни логове (Не изискват съгласие)\nКогато използвате нашите услуги през Вашия регистриран профил, ние събираме вътрешни системни данни за начина, по който взаимодействате с платформата (напр. превключване между табовете за арбитражи и пазарни аномалии, използване на калкулатора или отваряне на детайли за събитие). Тези данни се събират и съхраняват изцяло на наши защитени сървъри (first-party data) и не се споделят с външни платформи за анализ или рекламни мрежи.\n\nВ) Данни за анализ и маркетинг (Само при Ваше съгласие)\nКогато дадете своето изрично съгласие чрез нашия банер за бисквитки, ние използваме инструменти на трети страни (Google Analytics 4 и Meta Pixel), за да анализираме трафика на сайта, да разберем как потребителите взаимодействат с платформата и да оптимизираме нашите рекламни кампании. Тези инструменти могат да събират данни като:\n• IP адрес (анонимизиран);\n• Тип устройство и операционна система;\n• Вид браузър;\n• Посетени страници и взаимодействия със сайта (кликове, време прекарано на страницата).\n\nАко не дадете съгласие в банера за бисквитки, данните от категория "В" няма да бъдат събирани.'
      },
      section3: {
        title: '3. Специални категории данни',
        content: 'Не събираме или обработваме данни от специални категории (чувствителни данни), както са определени в чл. 9 GDPR.'
      },
      section4: {
        title: '4. Цел и правна основа на обработката',
        content: 'Обработваме лични данни само за целите, изброени по-долу:\n\n4.1 За регистрация и управление на вашия потребителски акаунт\n\n• Правна основа: чл. 6(1)(б) GDPR – изпълнение на договор (Общи условия).\n\n4.2 За предоставяне на нашите информационни услуги\n\nВключително достъп до арбитражни сигнали и статистически анализи.\n\n• Правна основа: чл. 6(1)(б) GDPR – изпълнение на договор.\n\n4.3 За сигурност и предотвратяване на злоупотреби\n\nВключително нашата система за управление на уникални сесии, която предотвратява едновременни влизания от множество устройства.\n\n• Правна основа: чл. 6(1)(е) GDPR – легитимен интерес (защита на интелектуалната собственост и предотвратяване на измами).\n\n4.4 За обработка на плащания\n\nПлащанията се обработват от лицензиран доставчик (Stripe). Ние не съхраняваме пълни данни за карти.\n\n• Правна основа: чл. 6(1)(б) GDPR.\n\n4.5 За спазване на законови задължения\n\nНапример: счетоводна отчетност и данъчни задължения.\n\n• Правна основа: чл. 6(1)(в) GDPR – спазване на законово задължение.\n\n4.6 Маркетингови имейли\n\nСамо ако изрично се абонирате.\n\n• Правна основа: чл. 6(1)(а) GDPR – съгласие.\n\n4.7 Подобряване и развитие на продукта\n\nНие анализираме данните за продуктовата Ви активност, за да разберем кои функционалности са най-полезни, да оптимизираме потребителския интерфейс (UX) и да развиваме инструментите си.\n• Правна основа: чл. 6(1)(е) GDPR – легитимен интерес.'
      },
      section5: {
        title: '5. Бисквитки и проследяващи технологии',
        content: 'Нашият уебсайт използва бисквитки. Разделяме ги на две основни категории:\n\n5.1. Строго необходими бисквитки (Не изискват съгласие)\nТе са задължителни за функционирането на платформата (автентикация, управление на сесии, сигурност). Без тях сайтът не може да работи правилно.\n\n5.2. Аналитични и маркетингови бисквитки (Изискват съгласие)\nНие използваме тези бисквитки само ако Вие изрично ги разрешите чрез нашия банер за бисквитки.\nGoogle Analytics 4 (Google Ireland Limited): Помага ни да разберем как потребителите взаимодействат със сайта, за да подобряваме услугата си.\nMeta Pixel (Meta Platforms Ireland Limited): Помага ни да измерваме ефективността на рекламите си в социалните мрежи и да показваме релевантни предложения.\n\nМожете да промените предпочитанията си или да оттеглите съгласието си по всяко време, като кликнете върху {{COOKIE_SETTINGS_LINK}}.'
      },
      section6: {
        title: '6. Обработка на плащания',
        content: 'Използваме Stripe като платежен процесор.\n\nНие не получаваме и не съхраняваме номера на Вашите банкови карти. ArbiWin.bg обработва само потвърждения за статус на плащане (успешно/неуспешно) и метаданни за абонамента (дата на подновяване, статус на абонамент).\n\nStripe действа като независим администратор на данни по отношение на финансовата информация.'
      },
      section7: {
        title: '7. Местоположение на съхранение на данни',
        content: 'Всички данни се съхраняват в инфраструктурата на Microsoft Azure – North Europe (Ирландия).\n\nНе прехвърляме лични данни извън Европейското икономическо пространство (ЕИП).'
      },
      section8: {
        title: '8. Съхранение на данни',
        content: 'Съхраняваме Вашите данни само колкото е необходимо за целите, за които са събрани, и в съответствие със законовите изисквания:\n\n• Информация за активен акаунт: Докато акаунтът е активен.\n• Счетоводни и платежни данни: 10 години (съгласно изискванията на Закона за счетоводството в България), независимо дали акаунтът е изтрит.\n• Сървърни логове и данни за сесии: До 12 месеца (за целите на сигурността).\n• Логове за продуктова активност: Съхраняват се за срок от 90 дни от датата на събитието, след което се изтриват автоматично от нашите системи.\n• Неактивни акаунти (без плащания): До 24 месеца след последната активност.'
      },
      section9: {
        title: '9. Сигурност на данните',
        content: 'Поддържаме високи технически стандарти за сигурност, включително:\n\n• Шифровани връзки (SSL/HTTPS);\n• Сигурно хеширане на пароли (Passwords are never stored in plain text);\n• Строг контрол на достъпа до базата данни;\n• Защити, предоставени от инфраструктурата на Azure.'
      },
      section10: {
        title: '10. Споделяне на лични данни',
        content: 'Не продаваме и не отдаваме под наем лични данни на трети страни.\n\nДанните могат да бъдат споделени само при строго необходимост с:\n\n• Процесори за плащане (Stripe);\n• Хостинг доставчик (Microsoft Azure);\n• Държавни органи (само при законово изискване);\n• Доставчици на комуникационни услуги (напр. Telegram FZ-LLC): Само ако изрично активирате функцията за нотификации чрез техните платформи.'
      },
      section11: {
        title: '11. Уебсайтове на трети страни',
        content: 'Платформата може да съдържа препратки към сайтове на трети страни (напр. имена на букмейкъри). Тази Политика за поверителност не се прилага за тези уебсайтове. Ние не носим отговорност за практиките за поверителност на трети страни.'
      },
      section12: {
        title: '12. Вашите права',
        content: 'Имате следните права спрямо Вашите лични данни:\n\n• Право на достъп;\n• Право на коригиране;\n• Право на изтриване („право да бъдете забравени“), с изключение на данни, които сме задължени да пазим по закон (напр. счетоводни данни);\n• Право на ограничаване на обработката;\n• Право на преносимост;\n• Право на възражение.\n\nЗа упражняване на правата си, моля свържете се с нас на: legal@arbiwin.bg.'
      },
      section13: {
        title: '13. Деца',
        content: 'Услугата е предназначена само за лица, навършили 18 години. Не обработваме умишлено данни на непълнолетни лица.'
      },
      section14: {
        title: '14. Промени в политиката',
        content: 'Можем да актуализираме тази Политика за поверителност периодично. Съществени промени ще бъдат комуникирани чрез съобщение на уебсайта или по имейл.'
      }
    },
    contact: {
      title: 'Свържете се с нас',
      description: 'Свържете се с екипа на ArbiWin.bg',
      intro: 'Имате въпрос относно услугата или нужда от техническа помощ? Нашият екип е на разположение.',
      section1: {
        title: '1. Клиентска поддръжка и технически въпроси',
        description: 'За въпроси относно абонаменти, достъп до платформата или технически проблеми:',
        emailLabel: '📧 Имейл',
        email: 'support@arbiwin.bg'
      },
      section2: {
        title: '2. Правни въпроси и Лични данни',
        description: 'За въпроси, свързани с Общите условия, Политиката за поверителност или упражняване на права по GDPR:',
        emailLabel: '📧 Имейл',
        email: 'legal@arbiwin.bg'
      },
      instructions: {
        title: 'Инструкции за по-бързо обслужване',
        intro: 'За да обработим Вашето запитване максимално бързо и сигурно, моля:',
        item1: 'Пишете от регистрирания имейл адрес: За Ваша сигурност, ние предоставяме информация за акаунт само ако запитването е изпратено от имейл адреса, асоцииран с Вашия профил.',
        item2: 'Опишете проблема: Ако съобщавате за технически проблем, моля включете кратко описание или снимка на екрана (screenshot).'
      },
      response: {
        title: 'Време за отговор',
        time: 'Стараем се да отговаряме на всички запитвания в рамките на 24 часа. В натоварени периоди или при сложни казуси, времето за отговор може да достигне до 5 работни дни.'
      },
      footer: {
        company: '„ВИ ВИ ЕС ВИ ТЕХ“ ЕООД',
        address: 'София, ул. Светла 10',
        terms: 'Общи условия',
        privacy: 'Политика за поверителност'
      }
    },
    about: {
      title: 'За нас',
      description: 'Информация за ArbiWin.bg',
      section1: {
        title: 'Кои сме ние',
        content: 'ArbiWin.bg е специализирана информационна платформа за статистически анализ на спортни пазари. Ние предоставяме инструменти за идентифициране на математически предимства (арбитражни ситуации), фокусирани изцяло върху лицензирания пазар в България.'
      },
      section2: {
        title: 'Нашата мисия',
        content: 'Нашата цел е да осигурим на потребителите прозрачен достъп до агрегирани пазарни данни, помагайки им да взимат информирани решения на базата на факти и математически модели, а не на хазартен принцип.'
      },
      section3: {
        title: 'Нашите предимства',
        content: 'Защо да изберете ArbiWin.bg:',
        item1: 'Фокус върху локалния пазар – Анализираме данни единствено от лицензирани в България оператори, което гарантира достъпност за българските потребители.',
        item2: 'Динамичен мониторинг – Системата ни сканира пазара и обновява информацията за коефициентите на чести интервали.',
        item3: 'Интегриран калкулатор – Автоматично изчисляване на оптималното разпределение на средствата за всяка арбитражна ситуация.',
        item4: 'Достъпност – Интуитивен интерфейс, създаден както за начинаещи, така и за напреднали потребители.'
      },
      section4: {
        title: 'Нашият екип',
        content: 'Зад ArbiWin.bg стои екип от специалисти в областта на анализа на данни (Data Science) и софтуерното инженерство. Ние обединяваме технологични умения с дълбоко познаване на спортните пазари, за да създадем продукт с висока добавена стойност.'
      },
      section5: {
        title: 'Свържете се с нас',
        content: 'Ние ценим обратната връзка. Ако имате въпроси или предложения за развитие на платформата, свържете се с нас на:',
        supportEmail: '📧 support@arbiwin.bg'
      }
    },
    subscribe: {
      title: 'Как да се абонирам',
      description: 'Информация за абонамента и цените',
      section1: {
        title: 'Защо да се абонирате',
        content: 'С активен абонамент отключвате пълния потенциал на платформата: ArbiWin SureBet (арбитраж), ArbiWin Value (Best Odds), Telegram известия, автоматичен калкулатор и професионални филтри.'
      },
      section2: {
        title: 'Цени и планове',
        content: 'Нашата платформа предлага единен абонаментен план с достъп до всички функции.'
      },
      pricing: {
        title: 'ArbiWin Premium: Пълен аналитичен достъп',
        amount: '€17.99',
        period: '(на месец)',
        featuresIncludes: 'Какво включва:',
        feature1: '✅ Модул Арбитражи: Неограничен достъп до всички арбитражни ситуации',
        feature2: '✅ Модул Пазарни Аномалии: Радар за най-високи стойности спрямо средните за пазара (само за Tier 1 лиги)',
        feature3: '✅ Telegram Известия: Автоматични аларми при засичане на изгодни позиции',
        feature4: '✅ Интегриран калкулатор: Оптимизация на капитала при арбитраж',
        feature5: '✅ Динамично опресняване на данните от 23 оператора',
        button: 'Регистрирай се сега',
        promoText: '🎁 3 Дни Безплатен Пробен Период (Само за нови абонати)',
        promoDisclaimer: '(Въведете метод на плащане за активиране. Няма да бъдете таксувани днес. Таксуването от €17.99 започва автоматично след изтичане на 3-дневния тест).',
      },
      section3: {
        title: 'Как да започнете',
        content: 'Следвайте тези стъпки, за да започнете да използвате ArbiWin.bg:'
      },
      steps: {
        step1: 'Създайте акаунт – регистрирайте се с Вашия имейл адрес.',
        step2: 'Стартирайте безплатния тест – въведете метод на плащане в сигурната система на Stripe (няма да бъдете таксувани днес).',
        step3: 'Незабавен достъп – веднага след активация виждате всички скрити данни безплатно за 3 дни.',
        step4: 'Открийте възможности – използвайте филтрите, за да намерите ситуациите, които отговарят на Вашата стратегия.',
        step5: 'Оптимизирайте играта си – използвайте калкулатора за прецизно разпределение на средствата.'
      },
      section4: {
        title: 'Често задавани въпроси',
        faqQuestion: 'Ще бъда ли таксуван днес?',
        content: 'Не. Първите 3 дни са напълно безплатни. Ще бъдете таксувани със стандартната месечна такса едва на 4-тия ден, освен ако не отмените абонамента си преди това.',
        faqQuestion2: 'Мога ли да се откажа?',
        content2: 'Да, можете да отмените абонамента си по всяко време през настройките на профила.'
      },
      section5: {
        title: 'Поддръжка',
        content: 'Ако имате въпроси относно плащания или абонаменти, моля свържете се с нас на:',
        supportEmail: '📧 support@arbiwin.bg'
      },
      footer: {
        company: '„ВИ ВИ ЕС ВИ ТЕХ“ ЕООД',
        address: 'София, ул. Светла 10',
        terms: 'Общи условия',
        privacy: 'Политика за поверителност'
      }
    }
  },

  marketing: {
    bulgarianFocus: {
      title: 'Създаден за българския пазар',
      description: 'Ние сме единствената платформа за анализи, посветена изключително на лицензирани български оператори.',
      benefit1: 'Само лицензирани оператори',
      benefit2: 'Съответствие с местните стандарти',
      benefit3: 'Поддръжка при необходимост',
      benefit4: 'Релевантни пазарни възможности',
      visualText: '100% BG Фокус'
    },
    advantages: {
      title: 'Основни предимства',
      subtitle: 'Защо ArbiWin е умният избор',
      advantage1: {
        title: 'Скорост',
        description: 'Бързото опресняване на данните гарантира, че виждате възможностите преди да изчезнат.'
      },
      advantage2: {
        title: 'Сигурност',
        description: 'Агрегираме данни само от регулирани субекти.'
      },
      advantage3: {
        title: 'Прозрачност',
        description: 'Без скрити такси. Достъп до всички инструменти с един абонамент.'
      },
      advantage4: {
        title: 'Удобство',
        description: 'Чист интерфейс, проектиран за ефективност, а не за объркване.'
      }
    },
    comparison: {
      title: 'Сравнение с други платформи',
      subtitle: 'Вижте защо ArbiWin.bg е най-добрият избор',
      feature: 'Функция',
      otherPlatforms: 'Други платформи',
      arbiwin: 'ArbiWin.bg',
      row1: {
        feature: 'Фокус върху българския пазар',
        other: 'Не',
        us: 'Да'
      },
      row2: {
        feature: 'Работа с лицензирани български букмейкъри',
        other: 'Ограничено',
        us: 'Пълна поддръжка'
      },
      row3: {
        feature: 'Данни в реално време (10 минути)',
        other: '15-30 минути',
        us: '10 минути'
      },
      row4: {
        feature: 'Автоматичен калкулатор',
        other: 'Ръчно изчисляване',
        us: 'Автоматично'
      },
      row5: {
        feature: 'Локализирано съдържание',
        other: 'Само английски',
        us: 'Български и английски'
      }
    },
    benefits: {
      title: 'Стойност на платформата',
      subtitle: 'Инструменти за по-умна спортна търговия',
      benefit1: {
        title: 'Хеджирай позициите си',
        description: 'Научете се да покривате всички изходи, за да си осигурите марж независимо от резултата.'
      },
      benefit2: {
        title: 'Telegram Автоматизация',
        description: 'Получавай мигновени сигнали директно на телефона си чрез нашия Telegram бот. Ти задаваш маржа, ние ти пращаме мача'
      },
      benefit3: {
        title: 'Прецизност',
        description: 'Калкулаторите елиминират грешките при смятане наум.'
      },
      benefit4: {
        title: 'Легитимност',
        description: 'Фокус върху законни печалби чрез лицензирани оператори.'
      },
      benefit5: {
        title: 'Филтриране',
        description: 'Виждайте само възможностите, които отговарят на стратегията ви.'
      },
      benefit6: {
        title: 'Образование',
        description: 'Ръководства и уроци за подобряване на търговската ви дисциплина.'
      }
    },
    trust: {
      title: 'Нашите ангажименти',
      subtitle: 'Надеждни данни и услуга',
      trust1: {
        title: 'Правно съответствие',
        description: 'Оперираме в пълно съответствие със законодателството на България и ЕС. Ние сме доставчик на професионални спортни анализи.'
      },
      trust2: {
        title: 'Ясни цени',
        description: 'Прост месечен абонамент. Отказ по всяко време.'
      },
      trust3: {
        title: 'Грижа за клиента',
        description: 'Специализиран екип за поддръжка, който помага с използването на платформата.'
      },
      trust4: {
        title: 'Потребителска база',
        description: 'Присъединете се към растяща общност от аналитични спортни търговци.'
      }
    },
    cta: {
      title: 'Готови ли сте да анализирате пазара?',
      description: 'Получете достъп до професионални данни за спортна търговия днес.',
      button: 'Започни',
      guarantee: '14-дневна гаранция за връщане на парите'
    }
  },

  header: {
    login: 'Вход',
    register: 'Регистрация',
    menu: 'Меню',
  },

  filters: {
    all: 'Всички',
    selectAll: 'Избери всички',
    deselectAll: 'Премахни всички',
    filterByBookmaker: 'Търсене на арбитражни възможности по оператор',
    searchBookmakers: 'Търсене на оператор...',
    clearSearch: 'Изчисти търсенето',
    noBookmakersFound: 'Няма намерени букмейкъри',
    selectedBookmakers: 'Избрани оператори',
    inactiveMode: 'Само за преглед',
    inactiveMessage: 'Абонирайте се, за да филтрирате по конкретни оператори и да видите пълните пазарни данни.',
    applyFilters: 'Приложи',
    resetFilters: 'Нулирай',
    activeFilters: 'Активни филтри',
    loading: 'Зареждане на букмейкъри...',
    refresh: 'Опресняване',
    refreshing: 'Опресняване...',
    lastUpdate: 'Последно обновяване',
    noUpdates: 'Няма обновявания',
    justNow: 'Току-що',
    oneMinuteAgo: 'Преди 1 минута',
    minutesAgo: 'Преди {minutes} минути',
    applying: 'Прилагане...',
      selectAtLeastOne: 'Моля, изберете поне един букмейкър',
      collapse: 'Свий',
      expand: 'Разгъни',
      // Filter Indicators
      indicators: {
        ariaLabel: 'Индикатори за активни филтри',
        activeFilters: 'Активни филтри',
        clearAll: 'Изчисти всички',
        selectedBookmakers: 'Избрани оператори',
        selected: 'Избран',
        remove: 'Премахни',
        more: 'още',
        showHidden: 'Покажи скритите ({count})',
        hiddenBookmakers: 'Скрити букмейкъри',
      },
      // Filter Search
      search: {
        placeholder: 'Търсене на оператори...',
        ariaLabel: 'Търсене на оператори',
        description: 'Въведете име на букмейкър за търсене',
        clear: 'Изчисти търсенето',
        suggestions: 'Предложения за търсене',
        noResults: 'Няма резултати за "{term}"',
      },
      // Filter Reset
      reset: {
        ariaLabel: 'Нулирай филтрите',
        title: 'Нулирай филтрите',
        reset: 'Нулирай',
        resetting: 'Нулиране...',
        clearAllAriaLabel: 'Изчисти всички филтри',
        clearAllTitle: 'Изчисти всички филтри',
        clearAll: 'Изчисти всички',
        confirmTitle: 'Потвърди нулиране',
        confirmMessage: 'Сигурни ли сте, че искате да нулирате всички филтри?',
        cancel: 'Отказ',
        confirm: 'Потвърди',
      },
      // Filter Drawer
      drawer: {
        title: 'Филтри',
        description: 'Настройте филтрите за букмейкъри',
        close: 'Затвори',
        searchPlaceholder: 'Търсене на оператори...',
        apply: 'Приложи',
      },
      // Filter Shortcuts
      shortcuts: {
        title: 'Бързи избори',
        description: 'Изберете предварително дефинирани комбинации от букмейкъри',
        all: 'Всички',
        allDescription: 'Покажи всички налични букмейкъри',
        popular: 'Популярни',
        popularDescription: 'Най-популярните букмейкъри в България',
        bulgarian: 'Български',
        bulgarianDescription: 'Български букмейкъри',
        international: 'Международни',
        internationalDescription: 'Международни букмейкъри',
        bookmakers: 'букмейкъри',
        createCustom: 'Създай персонализиран',
      },
  },

  footer: {
    description: 'Интелигентна платформа за агрегиране на данни, статистика и откриване на математически предимства.',
    quickLinks: 'Бързи връзки',
    learnMore: 'Научете повече',
    rights: '© {year} ArbiWin.bg. Всички права запазени.',
    copyright: '© 2026 ArbiWin.bg. Всички права запазени.',
    terms: 'Общи условия',
    privacy: 'Поверителност',
    contact: 'Контакт',
    cookieSettings: 'Настройки на бисквитките',
    about: 'За нас',
    howToSubscribe: 'Как да се абонирам',
    faq: 'Често задавани въпроси',
  },

  cookieConsent: {
    title: 'Ние ценим Вашата поверителност',
    message: 'Ние и нашите партньори използваме бисквитки (cookies) и подобни технологии, за да осигурим правилното функциониране на нашия уебсайт, да анализираме трафика, да персонализираме съдържанието и да Ви предлагаме реклами, съобразени с Вашите интереси.\n\nКато натиснете „Приемам всички“, Вие се съгласявате с използването на всички бисквитки.\n\nКато натиснете „Само задължителни“, ще бъдат използвани само бисквитките, които са абсолютно необходими за работата на сайта. Можете да промените своите предпочитания по всяко време чрез бутона „Настройки“. За повече информация, моля, запознайте се с нашата',
    acceptAll: 'Приемам всички',
    essentialOnly: 'Само задължителни',
    settings: 'Настройки',
    privacyLink: 'Политика за поверителност',
    settingsTitle: 'Настройки за бисквитки',
    necessaryCookies: 'Задължителни бисквитки (винаги активни)',
    necessaryCookiesDesc: 'Необходими за автентикация, сигурност и управление на сесиите. Сайтът не може да работи без тях.',
    analyticsMarketingCookies: 'Аналитика и маркетинг (GA4, Meta Pixel)',
    analyticsMarketingDesc: 'Използват се за подобряване на услугата и измерване на ефективността на кампаниите.',
    savePreferences: 'Запази настройките',
  },

  feedback: {
    loading: 'Зареждане...',
    error: 'Възникна грешка',
    success: 'Успех',
    retry: 'Опитайте отново',
  },

  validation: {
    required: 'Това поле е задължително',
    emailInvalid: 'Невалиден имейл адрес',
    passwordTooShort: 'Паролата трябва да е поне {min} символа',
    passwordsDoNotMatch: 'Паролите не съвпадат',
    minValue: 'Минимална стойност: {min}',
    maxValue: 'Максимална стойност: {max}',
    fullName: 'Въведете вашето пълно име',
    fullNameMinLength: 'Пълното име трябва да бъде поне 2 символа',
  },

  errors: {
    generic: 'Нещо се обърка. Моля опитайте отново по-късно.',
    network: 'Проблем с връзката. Проверете интернет връзката си.',
    unauthorized: 'Трябва да влезете в профила си.',
    forbidden: 'Нямате необходимите права.',
    notFound: 'Ресурсът не е намерен.',
    serverError: 'Сървърна грешка. Опитайте отново.',
    subscriptionRequired: 'Необходим е активен абонамент за достъп до тази функция.',
    http: {
      401: 'Невалидна сесия или изтекъл токен. Моля, влезте отново.',
      402: 'Необходим е активен абонамент.',
      403: 'Действието е забранено.',
      404: 'Не е намерено.',
      500: 'Вътрешна сървърна грешка.',
    },
  },

  auth: {
    login: {
      title: 'Вход',
      email: 'Имейл',
      password: 'Парола',
      rememberMe: 'Запомни ме',
      submit: 'Вход',
      forgotPassword: 'Забравена парола?',
      noAccount: 'Нямате профил?',
      success: 'Успешно влизане',
      error: 'Неуспешен опит за вход',
    },
    register: {
      title: 'Регистрация',
      fullName: 'Пълно име',
      email: 'Имейл',
      password: 'Парола',
      confirmPassword: 'Потвърди парола',
      submit: 'Създай профил',
      success: 'Успешна регистрация',
      successMessage: 'Вашият профил е създаден успешно! Моля, влезте в системата с вашите данни.',
      goToLogin: 'Отиди към вход',
      error: 'Регистрацията неуспешна',
      hasAccount: 'Вече имате профил?',
      emailExists: 'Този имейл вече се използва',
      passwordWeak: 'Слаба парола',
      passwordMedium: 'Средна парола',
      passwordStrong: 'Силна парола',
      passwordTooWeak: 'Паролата е твърде слаба',
      ageConfirmation: 'Потвърждавам, че съм навършил/а поне 18 години',
      ageConfirmationRequired: 'Трябва да потвърдите, че сте навършили поне 18 години',
      termsPrivacyAcceptPrefix: 'Запознат съм и приемам ',
      termsPrivacyAcceptAnd: ' и ',
      termsLinkText: 'Общите условия',
      privacyLinkText: 'Политиката за поверителност',
      termsPrivacyAcceptRequired: 'Трябва да приемете Общите условия и Политиката за поверителност.',
      requirementLength: 'Поне 8 символа',
      requirementLowercase: 'Малки букви',
      requirementUppercase: 'Главни букви',
      requirementNumbers: 'Цифри',
      requirementSpecial: 'Специални символи',
    },
    forgotPassword: {
      title: 'Забравена парола',
      subtitle: 'Въведете имейла си и ще изпратим линк за нулиране на паролата',
      email: 'Имейл',
      sendResetLink: 'Изпрати линк за нулиране',
      sending: 'Изпращане...',
      success: 'Линкът е изпратен',
      successMessage: 'Проверете имейла си за линк за нулиране на паролата. Линкът е валиден 24 часа.',
      backToLogin: 'Обратно към вход',
      error: 'Грешка при изпращане на линка',
    },
    resetPassword: {
      title: 'Нова парола',
      subtitle: 'Въведете новата си парола',
      newPassword: 'Нова парола',
      confirmNewPassword: 'Потвърди новата парола',
      resetPassword: 'Запази паролата',
      resetting: 'Запазване...',
      success: 'Паролата е нулирана успешно',
      successMessage: 'Вашата парола е променена успешно! Можете да влезете с новата си парола.',
      backToLogin: 'Обратно към вход',
      invalidToken: 'Невалиден или изтекъл линк за нулиране',
      error: 'Грешка при нулиране на паролата',
    },
    changePassword: {
      title: 'Смяна на парола',
      subtitle: 'Въведете текущата си парола и изберете нова',
      currentPassword: 'Текуща парола',
      currentPasswordPlaceholder: 'Въведете текущата си парола',
      newPassword: 'Нова парола',
      newPasswordPlaceholder: 'Въведете нова парола',
      confirmPassword: 'Потвърди новата парола',
      confirmPasswordPlaceholder: 'Потвърдете новата парола',
      requirements: 'Паролата трябва да бъде поне 8 символа дълга',
      changePassword: 'Смени паролата',
      changing: 'Смяна...',
      cancel: 'Отказ',
      returnToProfile: 'Обратно към профила',
      success: {
        title: 'Паролата е сменена успешно',
        message: 'Вашата парола е променена успешно! Можете да използвате новата парола за влизане.',
      },
      errors: {
        currentPasswordRequired: 'Текущата парола е задължителна',
        newPasswordRequired: 'Новата парола е задължителна',
        passwordTooShort: 'Паролата трябва да бъде поне 8 символа дълга',
        passwordsDoNotMatch: 'Новата парола и потвърждението не съвпадат',
        samePassword: 'Новата парола трябва да бъде различна от текущата',
        currentPasswordIncorrect: 'Текущата парола е неправилна',
        generic: 'Грешка при смяна на паролата',
        networkError: 'Грешка в мрежата. Моля опитайте отново.',
      },
    },

    // Calculator translations
    calculator: {
      title: 'Калкулатор за Арбитраж',
      marketType: 'Тип пазар',
      market2Way: '2-посочен пазар (напр. Над/Под)',
      market3Way: '3-посочен пазар (напр. 1X2)',
      coefficient: 'Коефициент',
      bookmaker: 'Букмейкър',
      outcome: 'Изход',
      totalStake: 'Обща сума за залагане (лв)',
      enterTotalStake: 'Въведете общата сума',
      calculatedStakes: 'Изчислени залози',
      stakeFor: 'Залог за',
      guaranteedProfit: 'Очаквана възвръщаемост (лв)',
      reset: 'Нулиране',
      calculate: 'Изчисли',
      calculating: 'Изчисляване...',
      profit: 'Печалба',
      loss: 'Загуба',
      neutral: 'Равно',
      // Modal translations
      modalTitle: 'Калкулатор за Арбитраж',
      modalTitleWithEvent: 'Калкулатор за {teamOne} срещу {teamTwo}',
      modalSubtitle: 'Изчислете оптималното разпределение на залозите за очаквана възвръщаемост',
      modalSubtitleWithEvent: '{championship} • {date} {time}',
      closeModal: 'Затвори калкулатора',
      close: 'Затвори',
      modalInfo: 'Данните са предварително попънени от избраната арбитражна възможност',
      // Outcome translations
      outcome1: 'Домакин Победа',
      outcomeX: 'Равенство',
      outcome2: 'Гост Победа',
      outcomeOver25: 'Над 2.5',
      outcomeUnder25: 'Под 2.5',
      outcomeBothScoreYes: 'Двата отбора ще вкарат',
      outcomeBothScoreNo: 'Не и двата отбора ще вкарат',
      outcome1X: '1X',
      outcomeX2: 'X2',
      outcome12: '12',
      outcomeYesGoal: 'Гол',
      outcomeNoGoal: 'Без гол',
      outcomeOver15: 'Над 1.5',
      outcomeUnder15: 'Под 1.5',
      outcomeOver35: 'Над 3.5',
      outcomeUnder35: 'Под 3.5',
      // Stake Calculator translations
      stakeCalculator: {
        title: 'Разпределение на Залозите',
        totalStake: 'Обща сума',
        guaranteedProfit: 'Очаквана възвръщаемост',
        profitPercentage: 'Процент печалба',
        arbitrageMargin: 'Арбитражен марж',
        bookmaker: 'Букмейкър',
        outcome: 'Изход',
        odds: 'Коефициент',
        stake: 'Залог',
        percentage: 'Процент',
        return: 'Възврат',
        adjustment: 'Корекция',
        adjustmentAria: 'Коректирай залога за {bookmaker}',
        resetAdjustments: 'Нулирай корекциите',
        copyStakes: 'Копирай залозите',
        copied: 'Копирано!',
        noDistribution: 'Няма разпределение на залозите',
        noDistributionHint: 'Въведете валидни коефициенти и обща сума за изчисляване на разпределението',
        validationErrors: 'Грешки при валидация',
        minStakeError: 'Минималният залог е {min} лв',
        maxStakeError: 'Максималният залог е {max} лв',
        negativeStakeError: 'Залогът не може да бъде отрицателен',
        totalStakeError: 'Общата изчислена сума не съответства на въведената',
      },
      // Profit Calculator translations
      profitCalculator: {
        title: 'Анализ на Печалбата',
        toggleComparison: 'Покажи сравнение',
        guaranteedProfit: 'Очаквана възвръщаемост',
        totalROI: 'Общ ROI',
        arbitrageMargin: 'Арбитражен марж',
        riskLevel: 'Ниво на риск',
        riskFree: 'Без риск',
        profitScenarios: 'Сценарии за печалба',
        scenariosDescription: 'Очаквана възвръщаемост независимо от резултата',
        stake: 'Залог',
        odds: 'Коефициент',
        return: 'Възврат',
        profit: 'Печалба',
        roi: 'ROI',
        profitBreakdown: 'Разпределение на печалбата по букмейкъри',
        stakePercentage: 'Процент залог',
        potentialReturn: 'Потенциален възврат',
        comparisonTitle: 'Сравнение с залагане в един букмейкър',
        comparisonMethod: 'Метод на сравнение',
        highestOdds: 'Най-високи коефициенти',
        averageOdds: 'Средни коефициенти',
        lowestOdds: 'Най-ниски коефициенти',
        singleBookmaker: 'Един букмейкър',
        potentialProfit: 'Потенциална печалба',
        highRisk: 'Висок риск',
        arbitrageAdvantage: 'Предимство на арбитража',
        arbitrageAdvantageDescription: 'Очаквана възвръщаемост спрямо потенциална възвръщаемост с риск',
        riskFreeTitle: 'Безрисков арбитраж',
        riskFreeDescription: 'Арбитражното залагане гарантира печалба независимо от резултата. За разлика от традиционното залагане, не можете да загубите пари с правилно изчислена арбитражна възможност.',
        guaranteedProfitBenefit: 'Очаквана възвръщаемост при всеки резултат',
        noRiskBenefit: 'Няма риск от загуба на залога',
        consistentReturnsBenefit: 'Постоянни възвращаемости независимо от резултатите',
      },
    },
    fields: {
      email: 'Имейл',
      password: 'Парола',
      newPassword: 'Нова парола',
      confirmNewPassword: 'Потвърди новата парола',
    },
    placeholders: {
      email: 'Въведете имейла си',
      newPassword: 'Въведете нова парола',
      confirmNewPassword: 'Потвърдете новата парола',
    },
    validation: {
      emailRequired: 'Имейлът е задължителен',
      emailInvalid: 'Невалиден имейл адрес',
      passwordRequired: 'Паролата е задължителна',
      confirmPasswordRequired: 'Потвърждението на паролата е задължително',
      passwordsDoNotMatch: 'Паролите не съвпадат',
      passwordInvalid: 'Паролата не отговаря на изискванията',
      minLength: 'Поне 8 символа',
      hasUpperCase: 'Главна буква',
      hasLowerCase: 'Малка буква',
      hasNumbers: 'Цифра',
      hasSpecialChar: 'Специален символ',
    },
    sessionConflict: {
      title: 'Друга сесия е активна',
      message: 'Друга сесия е активна на този акаунт. Моля влезте отново.',
      loginButton: 'Вход'
    },
    sessionTerminated: {
      title: 'Сесията е прекратена',
      message: 'Сесията ви е прекратена. Моля влезте отново.',
      loginButton: 'Вход'
    },
    sessionInvalid: {
      title: 'Сесията не е валидна',
      message: 'Вашата сесия не е валидна или е била отменена. Моля излезте и влезте отново, за да продължите.',
      logoutButton: 'Изход'
    },
  },

  subscription: {
    title: 'ArbiWin Premium',
    titleUltimate: 'ArbiWin Ultimate',
    status: {
      active: 'Активен',
      inactive: 'Неактивен',
      expired: 'Изтекъл',
      none: 'Няма абонамент',
      suspended: 'Спрян',
      cancelled: 'Отменен',
      loading: 'Зареждане...',
      error: 'Грешка',
    },
    types: {
      basic: 'Базов план',
      premium: 'Премиум план',
      enterprise: 'Корпоративен план',
      none: 'Няма план',
    },
    pricing: {
      basic: '€17.99/месец',
      premium: '€17.99/месец',
      enterprise: '€17.99/месец',
      ultimate: '€200/месец',
      none: 'Безплатно',
    },
    labels: {
      status: 'Статус на абонамента',
      expiryDate: 'Дата на изтичане',
      renewalDate: 'Дата на подновяване',
      nextPayment: 'Следващо плащане',
      activatedDate: 'Дата на активиране',
      daysRemaining: 'Оставащи дни',
    },
    days: {
      remaining: 'дни остават',
      overdue: 'дни изминали',
    },
    dates: {
      notSet: 'Не е зададена',
      invalid: 'Невалидна дата',
    },
    actions: {
      activate: 'Активирай абонамент',
      activating: 'Активиране...',
      changePlan: 'Смени план',
      cancel: 'Отмени абонамент',
      cancelling: 'Отмяна...',
      renew: 'Поднови абонамент',
      renewing: 'Подновяване...',
      retry: 'Опитайте отново',
      goBack: 'Назад',
    },
    modals: {
      activate: {
        title: 'Потвърждение за активиране на абонамент',
        message: 'Сигурни ли сте, че искате да активирате абонамента?',
        confirm: 'Потвърди'
      },
      cancel: {
        title: 'Потвърждение за отмяна на абонамент',
        message: 'Сигурни ли сте, че искате да отмените абонамента? Това действие ще доведе до загуба на достъпа до премиум функциите и арбитражните възможности.',
        confirm: 'Потвърди'
      },
      cancelButton: 'Отказ',
      keep: 'Отказ'
    },
    errors: {
      activationFailed: 'Неуспешно активиране на абонамента. Моля опитайте отново.',
      cancellationFailed: 'Неуспешна отмяна на абонамента. Моля опитайте отново.',
      networkError: 'Мрежова грешка. Моля проверете интернет връзката си.',
      serverError: 'Сървърна грешка. Моля опитайте отново по-късно.',
      checkTitle: 'Грешка при проверка на абонамента',
      checkStatusFailed: 'Не може да се провери статусът на абонамента. Моля опитайте отново.'
    },
    paymentRequired: {
      title: 'Необходим е активен абонамент',
      message: 'За достъп до тази функция е необходим активен абонамент.',
      messageWithFeature: 'За достъп до {feature} е необходим активен абонамент.',
      featuresTitle: 'Какво получавате с абонамента:',
      features: {
        surebets: 'Арбитражни възможности',
        calculator: 'Калкулатор за залози',
        realTime: 'Данни в реално време',
        support: 'Приоритетна поддръжка'
      },
      perMonth: 'на месец',
      pricingNote: 'Първият месец е безплатен',
      later: 'По-късно',
      activateNow: 'Активирай сега'
    },
    loading: {
      status: 'Зареждане на статуса на абонамента...',
      activation: 'Активиране на абонамента...',
      cancellation: 'Отмяна на абонамента...'
    },
    activate: 'Активирай абонамент',
    activateConfirm: 'Сигурни ли сте, че искате да активирате абонамента?',
    activatedSuccess: 'Абонаментът е активиран успешно!',
    inactiveNotice: 'Неактивен абонамент',
    required: 'Необходим е активен абонамент за достъп до тази функция',
    expiry: 'Валиден до: {date}',
    renewal: 'Дата на подновяване: {date}',
    checking: 'Проверка на абонамента...',
    retryAttempt: 'Опит {count}',
  },

  stripe: {
    product: {
      title: 'ArbiWin Premium',
      price: '€17.99 / месец',
      checkout: 'Активирай Безплатен Тест',
      manageBilling: 'Управление на карти и фактури',
      noPaymentData: 'Все още нямате запазени данни за плащане.',
      securityNote: '100% Сигурност със Stripe. Вашите данни са криптирани. Без допълнителни такси.',
    },
    success: {
      title: 'Абонаментът към ArbiWin Premium е успешен!',
      heroTitle: 'Абонаментът е активиран успешно!',
      heroSubtitle: 'Вие вече имате достъп до всички инструменти за анализ и арбитражни възможности. Успех!',
      orderDetails: 'Детайли на поръчката',
      plan: 'План',
      status: 'Статус',
      statusActive: 'Активен',
      nextPayment: 'Следващо плащане',
      nextPaymentValue: '–',
      gotoSurebets: 'Към арбитражни възможности',
      manageBilling: 'Управление на фактуриране',
    },
    messages: {
      canceled: 'Поръчката е отменена -- продължете да разглеждате и платете, когато сте готови.',
    },
    errors: {
      notAuthenticated: 'Моля влезте в профила си, за да продължите',
      checkoutFailed: 'Неуспешно създаване на сесия за плащане',
      portalFailed: 'Неуспешно създаване на сесия за портал',
      noSessionId: 'Липсва идентификатор на сесията',
    },
  },

  profile: {
    title: 'Профил',
    sections: {
      accountInfo: 'Информация за акаунта',
      securitySubscription: 'Сигурност и абонамент',
      subscriptionStatus: 'Статус на абонамента'
    },
    fields: {
      email: 'Имейл адрес'
    },
    actions: {
      changePassword: 'Смени парола',
      subscriptionDetails: 'Детайли за абонамента',
      logout: 'Изход',
      back: 'Назад'
    },
    notifications: {
      title: '🔔 Нотификационен център',
      subtitle: 'Получавайте мигновени известия за нови пазарни неефективности и аномалии директно на телефона си.',
      loading: 'Зареждане на настройки...',
      subscriptionRequired: 'Необходим е активен абонамент за управление на Telegram известията.',
      connected: 'Telegram е свързан успешно!',
      disconnected: 'Telegram връзката е премахната.',
      enabled: 'Известията са активирани.',
      saved: 'Настройките са запазени',
      linkError: 'Неуспешно генериране на Telegram линк.',
      connect: {
        heading: 'Свързване с Telegram',
        text: 'За да активирате известията, свържете своя ArbiWin профил с нашия официален Telegram бот.',
        button: 'Свържи с Telegram',
        helper: 'С кликване ще се отвори Telegram. Натиснете бутона START (не само /start) — той изпраща вашия уникален код за свързване.',
        waiting: 'Изчакване на потвърждение от Telegram...',
        pollTimeout: 'Не получихме потвърждение от Telegram. Отворете линка отново и натиснете START.'
      },
      settings: {
        heading: 'Настройка на известията',
        generalHeading: 'Общи настройки',
        enabledToggle: 'Активни известия',
        paused: 'Известията са на пауза',
        quietHoursToggle: '🌙 Тихи часове (00:00–08:00)',
        quietHoursHelper: 'При включване известията се спират автоматично между 00:00 и 08:00 ч. (Europe/Sofia).',
        arbitrageFilterHeading: '⚖️ Филтър: Арбитражни ситуации',
        arbitrageFilterToggle: 'Включи известия за арбитражни ситуации',
        marginLabel: 'Изпращай ми известие, когато системата засече сигурен арбитражен марж по-голям от:',
        marginPlaceholder: 'напр. 3.0',
        bestOddsFilterHeading: '🚀 Филтър: Пазарни аномалии (Best Odds - само Топ Лиги)',
        bestOddsFilterToggle: 'Включи известия за пазарни аномалии',
        spreadLabel: 'Изпращай ми известие, когато системата засече стойност, чието отклонение (Spread) спрямо средната за пазара е над:',
        spreadPlaceholder: 'напр. 5.0',
        antiSpam: {
          title: '🛡️ Смарт Анти-Спам защита:',
          intro: 'За да не препълваме чата Ви, нашата система използва двоен интелигентен филтър:',
          arbitrage: 'За Арбитражи: След получаване на сигнал, известията за същия мач се паузират за следващите 4 часа.',
          bestOdds: 'За Пазарни Аномалии: Получавате известие само когато стойността (коефициентът) се покачи и достигне нов връх. След това, известията за този конкретен изход (напр. Победа за Домакин) се паузират за 24 часа. Ако обаче се появи аномалия за друг изход в същия мач (напр. Равенство), веднага ще бъдете известени.',
        },
        save: 'Запази настройките',
        savedButton: 'Запазено ✓',
        saveErrorGeneric: 'Неуспешно запазване на настройките. Опитайте отново.',
        disconnect: 'Разкачи Telegram',
        minFloorError: 'Минималният праг е 1.0%.',
        minSpreadFloorError: 'Минималният праг е 5.0%.'
      }
    }
  },

  surebets: {
    list: {
      title: 'Арбитражни възможности',
      subtitle: 'Анализ на арбитражни възможности и динамични пазарни данни за спортни събития.',
      noData: 'Няма налични арбитражни възможности в момента',
      loading: 'Зареждане на данни...',
      refreshing: 'Обновяване...',
      lastUpdate: 'Последно обновяване',
      profit: 'Печалба',
      margin: 'Марж',
      event: 'Събитие',
      date: 'Дата',
      time: 'Час',
      championship: 'Първенство',
      sport: 'Спорт',
      refreshButton: 'Обнови данни',
      calculatorButton: 'Калкулатор',
      marginFlag: 'Печеливш',
      noMarginData: 'Няма данни за марж',
    },
    filters: {
      title: 'Филтри',
      bookmakers: 'Букмейкъри',
      selectAll: 'Избери всички',
      deselectAll: 'Премахни всички',
      apply: 'Приложи филтри',
      activeCount: 'Активни филтри: {count}',
    },
    marginTypes: {
      margin1X2: 'Краен резултат',
      marginOverUnder2AndHalf: 'Над/Под 2.5 гола',
      marginBothScore: 'Двата отбора ще вкарат',
      marginDoubleChance: 'Двоен шанс',
      margin1Xvs2: '1X срещу 2',
      marginX2vs1: 'X2 срещу 1',
      margin12vsX: '12 срещу X',
      marginOverUnder1AndHalf: 'Над/Под 1.5 гола',
      marginOverUnder3AndHalf: 'Над/Под 3.5 гола',
    },
    outcomes: {
      Coef1: 'Домакин Победа',
      CoefX: 'Равенство',
      Coef2: 'Гост Победа',
      CoefGoalOver2AndHalf: 'Над 2.5',
      CoefGoalUnder2AndHalf: 'Под 2.5',
      CoefBothScoreYes: 'Да',
      CoefBothScoreNo: 'Не',
      Coef1X: 'Домакин Победа или Равен',
      CoefX2: 'Равен или Гост Победа',
      Coef12: 'Домакин Победа или Гост Победа',
      CoefYesGoal: 'Гол',
      CoefNoGoal: 'Без гол',
      CoefGoalOver1AndHalf: 'Над 1.5',
      CoefGoalUnder1AndHalf: 'Под 1.5',
      CoefGoalOver3AndHalf: 'Над 3.5',
      CoefGoalUnder3AndHalf: 'Под 3.5',
    },
    bookmakers: {
      betano: 'Betano',
      bet365: 'Bet365',
      winbet: 'Winbet',
      betwild: 'Betwild',
      slybet: 'Slybet',
      bwin: 'Bwin',
      efbet: 'Efbet',
      inbet: 'Inbet',
      alphawin: 'Alphawin',
      sesame: 'Sesame',
      elitbet: 'Elitbet',
      bethub: 'Bethub',
      bet: 'Bet.bg',
      topwin: 'Topwin',
      mrbit: 'MrBit',
      admiralbet: 'Admiralbet',
      bg8888: '8888.bg',
      palmsbet: 'Palmsbet',
      everbet: 'Everbet',
      magicbet: 'Magicbet',
      betvam: 'Betvam',
      qbet: 'Qbet',
      imperiabet: 'Imperiabet',
    },
    calculator: {
      title: 'Арбитражен калкулатор',
      modalTitle: 'Арбитражен калкулатор',
      modalTitleWithEvent: 'Калкулатор за {teamOne} срещу {teamTwo}',
      modalSubtitle: 'Изчислете оптималното разпределение на залозите за очаквана възвръщаемост',
      modalSubtitleWithEvent: '{championship} • {date} {time}',
      modalInfo: 'Данните са предварително попънени от избраната арбитражна възможност',
      closeModal: 'Затвори калкулатора',
      close: 'Затвори',
      totalStake: 'Общ бюджет за разпределение',
      totalStakePlaceholder: 'Въведете общ бюджет',
      distribution: 'Оптимално разпределение',
      guaranteedProfit: 'Очаквана възвръщаемост (ROI)',
      profitPercentage: 'Процент печалба',
      bookmaker: 'Букмейкър',
      outcome: 'Изход',
      coefficient: 'Коефициент',
      stake: 'Залог',
      profit: 'Печалба',
      calculate: 'Изчисли',
      calculating: 'Изчисляване...',
      reset: 'Нулиране',
      copyStakes: 'Копирай залозите',
      stakescopied: 'Залозите са копирани в клипборда',
      minStakeWarning: 'Минимален залог: {amount} лв',
      invalidStake: 'Невалидна сума за залагане',
      eventDetails: 'Детайли за събитието',
      marketType: 'Тип пазар',
      market2Way: '2-посочен пазар',
      market3Way: '3-посочен пазар',
      market2WayDetailed: '2-посочен (напр. Двата отбора да отбележат, Под/Над)',
      market3WayDetailed: '3-посочен (1X2 Краен резултат)',
      enterTotalStake: 'Въведете общ бюджет за разпределение',
      calculatedStakes: 'Оптимално разпределение',
      stakeFor: 'Сума за позиция',
      positionProfit: 'Очаквана възвръщаемост (позиция "{outcome}"): {amount} EUR',
      overallRoi: 'Обща очаквана възвръщаемост (ROI)',
      expectedResult: 'Очакван резултат',
      stakeFieldReadOnlyHint: 'Кликнете, за да фиксирате тази позиция',
      stakeFieldEditableHint: 'Фиксирана позиция — останалите се преизчисляват автоматично',
      stakeFieldAnchoredHint: 'Ръчна позиция — общият бюджет е заключен',
      stakeFieldDerivedHint: 'Изчислена позиция — от заключения общ бюджет',
      stakeFieldPromoteHint: 'Кликнете, за да зададете ръчно тази позиция',
      totalBudgetLockedHint: 'Общият бюджет е заключен, докато има ръчно зададени позиции',
      // Outcome labels
      outcome1: 'Домакин Победа',
      outcomeX: 'Равенство',
      outcome2: 'Гост Победа',
      outcomeOver25: 'Над 2.5',
      outcomeUnder25: 'Под 2.5',
      outcomeBothScoreYes: 'Двата отбора ще вкарат',
      outcomeBothScoreNo: 'Двата отбора няма да вкарат',
      outcome1X: '1X',
      outcomeX2: 'X2',
      outcome12: '12',
      outcomeYesGoal: 'Гол',
      outcomeNoGoal: 'Без гол',
      outcomeOver15: 'Над 1.5',
      outcomeUnder15: 'Под 1.5',
      outcomeOver35: 'Над 3.5',
      outcomeUnder35: 'Под 3.5',
    },
  },

  notifications: {
    unread: {
      one: 'Имате {count} непрочетено известие',
      other: 'Имате {count} непрочетени известия',
    },
    copied: 'Копирано в клипборда',
  },

  accessibility: {
    skipToContent: 'Прескочи към съдържанието',
    openMenu: 'Отвори меню',
    closeMenu: 'Затвори меню',
    header: 'Хедър',
    footer: 'Футър',
    main: 'Основно съдържание',
  },

  surebets: {
    list: {
      ariaLabel: 'Списък с арбитражни възможности',
      title: 'Арбитражни възможности',
      total: 'Общо',
      profitable: 'Печеливши',
      refreshButton: 'Опресняване',
      lastUpdate: 'Последно обновяване',
      loading: 'Зареждане на арбитражи...',
      refreshing: 'Обновяване...',
      justNow: 'Току-що',
      oneMinuteAgo: 'Преди 1 минута',
      minutesAgo: 'Преди {minutes} минути',
      neverRefreshed: 'Никога',
      noData: 'Няма налични арбитражи',
      noDataTitle: 'Няма намерени арбитражни възможности',
      noDataDescription: 'В момента няма налични арбитражни възможности. Опитайте отново по-късно или променете филтрите.',
      errorTitle: 'Грешка при зареждане',
      errorDescription: 'Възникна грешка при зареждането на арбитражните възможности.',
      retryButton: 'Опитай отново',
      errorHelp: 'Ако проблемът продължава, моля свържете се с поддръжката.',
      tips: 'Съвети:',
      tip1: 'Проверявайте за нови възможности периодично',
      tip2: 'Използвайте филтрите за оператори, за да персонализирате резултатите',
      tip3: 'Бързата реакция е ключова за арбитражните възможности',
    },
    refresh: {
      refresh: 'Опресняване',
      refreshing: 'Обновяване...',
      refreshButton: 'Обнови данни',
      lastUpdate: 'Последно обновяване',
      nextRefresh: 'Следващо обновяване',
      justNow: 'Току-що',
      secondsAgo: 'Преди {seconds} секунди',
      oneMinuteAgo: 'Преди 1 минута',
      minutesAgo: 'Преди {minutes} минути',
      neverRefreshed: 'Никога',
      pause: 'Пауза',
      resume: 'Възобнови',
      paused: 'На пауза',
      pausedMessage: 'Автоматичното обновяване е на пауза',
      autoRefresh: 'Автоматично обновяване',
      autoRefreshOn: 'Автоматично обновяване включено',
      autoRefreshOff: 'Автоматично обновяване изключено',
      offline: 'Офлайн',
      offlineWarning: 'Няма връзка с интернет',
      rateLimitExceeded: 'Твърде много опити за обновяване',
    },
    card: {
      ariaLabel: 'Арбитражна възможност',
      vs: 'срещу',
      market: 'Пазар',
      bookmakerOdds: 'Оператор и коефициент',
      profit: 'Марж',
      actions: 'Действия',
      calculatorButton: 'Калкулатор',
      noMarginData: 'Няма данни за марж',
      noCoefficients: 'Няма коефициенти',
    },
    marginTypes: {
      margin1X2: 'Краен резултат (1X2)',
      marginOverUnder2AndHalf: 'Над/Под 2.5 гола',
      marginBothScore: 'Двата отбора ще вкарат',
      marginDoubleChance: 'Двоен шанс',
      margin1Xvs2: '1X срещу 2',
      marginX2vs1: 'X2 срещу 1',
      margin12vsX: '12 срещу X',
      marginOverUnder1AndHalf: 'Над/Под 1.5 гола',
      marginOverUnder3AndHalf: 'Над/Под 3.5 гола',
    },
    outcomes: {
      Coef1: '1',
      CoefX: 'X',
      Coef2: '2',
      CoefGoalOver2AndHalf: 'Над 2.5',
      CoefGoalUnder2AndHalf: 'Под 2.5',
      CoefBothScoreYes: 'Да',
      CoefBothScoreNo: 'Не',
      Coef1X: 'Домакин Победа или Равен',
      CoefX2: 'Равен или Гост Победа',
      Coef12: 'Домакин Победа или Гост Победа',
      CoefYesGoal: 'Гол',
      CoefNoGoal: 'Без гол',
      CoefGoalOver1AndHalf: 'Над 1.5',
      CoefGoalUnder1AndHalf: 'Под 1.5',
      CoefGoalOver3AndHalf: 'Над 3.5',
      CoefGoalUnder3AndHalf: 'Под 3.5',
    },
    calculator: {
      title: 'Арбитражен калкулатор',
      modalTitle: 'Арбитражен калкулатор',
      modalTitleWithEvent: 'Калкулатор за {teamOne} срещу {teamTwo}',
      modalSubtitle: 'Изчислете оптималното разпределение на залозите за очаквана възвръщаемост',
      modalSubtitleWithEvent: '{championship} • {date} {time}',
      modalInfo: 'Данните са предварително попънени от избраната арбитражна възможност',
      closeModal: 'Затвори калкулатора',
      close: 'Затвори',
      totalStake: 'Общ бюджет за разпределение',
      totalStakePlaceholder: 'Въведете общ бюджет',
      distribution: 'Оптимално разпределение',
      guaranteedProfit: 'Очаквана възвръщаемост (ROI)',
      profitPercentage: 'Процент печалба',
      bookmaker: 'Букмейкър',
      outcome: 'Изход',
      coefficient: 'Коефициент',
      stake: 'Залог',
      profit: 'Печалба',
      calculate: 'Изчисли',
      calculating: 'Изчисляване...',
      reset: 'Нулиране',
      copyStakes: 'Копирай залозите',
      stakescopied: 'Залозите са копирани в клипборда',
      minStakeWarning: 'Минимален залог: {amount} лв',
      invalidStake: 'Невалидна сума за залагане',
      eventDetails: 'Детайли за събитието',
      marketType: 'Тип пазар',
      market2Way: '2-посочен пазар',
      market3Way: '3-посочен пазар',
      market2WayDetailed: '2-посочен (напр. Двата отбора да отбележат, Под/Над)',
      market3WayDetailed: '3-посочен (1X2 Краен резултат)',
      enterTotalStake: 'Въведете общ бюджет за разпределение',
      calculatedStakes: 'Оптимално разпределение',
      stakeFor: 'Сума за позиция',
      positionProfit: 'Очаквана възвръщаемост (позиция "{outcome}"): {amount} EUR',
      overallRoi: 'Обща очаквана възвръщаемост (ROI)',
      expectedResult: 'Очакван резултат',
      stakeFieldReadOnlyHint: 'Кликнете, за да фиксирате тази позиция',
      stakeFieldEditableHint: 'Фиксирана позиция — останалите се преизчисляват автоматично',
      stakeFieldAnchoredHint: 'Ръчна позиция — общият бюджет е заключен',
      stakeFieldDerivedHint: 'Изчислена позиция — от заключения общ бюджет',
      stakeFieldPromoteHint: 'Кликнете, за да зададете ръчно тази позиция',
      totalBudgetLockedHint: 'Общият бюджет е заключен, докато има ръчно зададени позиции',
      outcome1: 'Домакин Победа',
      outcomeX: 'Равенство',
      outcome2: 'Гост Победа',
      outcomeOver25: 'Над 2.5',
      outcomeUnder25: 'Под 2.5',
      outcomeBothScoreYes: 'Двата отбора ще вкарат',
      outcomeBothScoreNo: 'Двата отбора няма да вкарат',
      outcome1X: '1X',
      outcomeX2: 'X2',
      outcome12: '12',
      outcomeYesGoal: 'Гол',
      outcomeNoGoal: 'Без гол',
      outcomeOver15: 'Над 1.5',
      outcomeUnder15: 'Под 1.5',
      outcomeOver35: 'Над 3.5',
      outcomeUnder35: 'Под 3.5',
    },
    viewFilters: {
      shownCount: 'Показани {filtered} от {total}',
      searchPlaceholder: 'Търси отбор или първенство...',
      searchAriaLabel: 'Търсене по отбор или първенство',
      searchClear: 'Изчисти търсенето',
      searchClearAriaLabel: 'Изчисти полето за търсене',
      marginLabel: 'Минимално отклонение',
      marginAll: 'Всички',
      marginChip: '≥ {value}%',
      marginChipAriaLabel: 'Филтрирай арбитражи с марж поне {value}%',
      marginAllAriaLabel: 'Покажи всички арбитражи без филтър по марж',
      panelToggleShow: 'Покажи филтри',
      panelToggleHide: 'Скрий филтри',
      panelAriaLabel: 'Допълнителни филтри за арбитражни възможности',
      championshipsLabel: 'Първенства',
      championshipsSelectAll: 'Избери всички',
      championshipsDeselectAll: 'Премахни всички',
      championshipsSearchPlaceholder: 'Търси първенство...',
      championshipsAriaLabel: 'Филтър по първенство',
      championshipsNone: 'Първенства: 0',
      marketsLabel: 'Тип пазар',
      marketsSelectAll: 'Избери всички',
      marketsDeselectAll: 'Премахни всички',
      marketsAriaLabel: 'Филтър по тип пазар',
      marketsNone: 'Пазари: 0',
      timeWindowLabel: 'Времеви прозорец',
      timeWindowAll: 'Всички',
      timeWindowToday: 'Днес',
      timeWindowNext24h: 'Следващите 24ч',
      timeWindowNext48h: 'Следващите 48 часа',
      timeWindowAriaLabel: 'Филтър по време на мача',
      timeWindowAllAriaLabel: 'Покажи арбитражи без филтър по време',
      activeFilters: 'Активни филтри',
      clearAll: 'Изчисти всички',
      clearAllAriaLabel: 'Изчисти всички филтри за арбитражния списък',
      clearFilters: 'Изчисти филтрите',
      removeFilterAriaLabel: 'Премахни филтър {name}',
      emptyFilteredTitle: 'Няма резултати с тези филтри',
      emptyFilteredDescription: 'Опитайте с по-широки критерии или изчистете активните филтри.',
    },
  },
  bestOdds: {
    radar: {
      title: 'Best Odds Радар',
      total: 'Активни аномалии',
      topSpread: 'Най-голямо отклонение',
      refreshButton: 'Опресняване',
      lastUpdate: 'Последно обновяване',
      refreshing: 'Обновяване...',
      justNow: 'Току-що',
      oneMinuteAgo: 'Преди 1 минута',
      minutesAgo: 'Преди {minutes} минути',
      neverRefreshed: 'Никога',
      ariaLabel: 'Списък с Best Odds сигнали',
      loading: 'Зареждане на Best Odds сигнали...',
      noDataTitle: 'Няма открити аномалии',
      noDataDescription: 'В момента няма открити пазарни аномалии в Tier 1 първенствата. Опитайте отново по-късно.',
      errorTitle: 'Грешка при зареждане',
      errorDescription: 'Възникна грешка при зареждането на Best Odds сигналите.',
      retryButton: 'Опитай отново',
    },
    card: {
      ariaLabel: 'Best Odds сигнал',
      newBestOddsBadge: 'НОВ НАЙ-ДОБЪР КОЕФИЦИЕНТ',
      marketAvgLabel: 'Пазарна средна',
      spreadLabel: 'Отклонение',
      bookmakerCountLabel: 'Букмейкъри',
      viewButton: 'Преглед',
    },
    modal: {
      title: 'Детайли за пазарна аномалия',
      eventDetails: 'Детайли за събитието',
      marketType: 'Тип пазар',
      bestOddsLabel: 'Най-добър коефициент',
      marketAvgLabel: 'Пазарна средна',
      spreadLabel: 'Отклонение',
      bookmakerCountLabel: 'Брой букмейкъри',
      oddsLadderTitle: 'Всички коефициенти',
      oddsLadderBookmaker: 'Букмейкър',
      oddsLadderOdds: 'Коефициент',
      close: 'Затвори',
    },
    filters: {
      searchPlaceholder: 'Търси отбор или първенство...',
      searchAriaLabel: 'Търсене по отбор или първенство',
      searchClear: 'Изчисти търсенето',
      searchClearAriaLabel: 'Изчисти полето за търсене',
      spreadLabel: 'Минимално отклонение',
      spreadAll: 'Всички',
      spreadChip: '≥ {value}%',
      spreadChipAriaLabel: 'Филтрирай аномалии с отклонение поне {value}%',
      spreadAllAriaLabel: 'Покажи всички аномалии без филтър по отклонение',
      maxOddsLabel: 'Максимален коефициент',
      maxOddsAll: 'Всички',
      maxOddsChip: '≤ {value}',
      maxOddsChipAriaLabel: 'Филтрирай аномалии с коефициент най-много {value}',
      maxOddsAllAriaLabel: 'Покажи всички аномалии без филтър по максимален коефициент',
      bookmakersLabel: 'Букмейкъри',
      bookmakersSelectAll: 'Избери всички',
      bookmakersDeselectAll: 'Премахни всички',
      bookmakersSearchPlaceholder: 'Търси букмейкър...',
      bookmakersAriaLabel: 'Филтър по букмейкър с най-добър коефициент',
      shownCount: 'Показани {filtered} от {total}',
      activeFilters: 'Активни филтри',
      clearFilters: 'Изчисти филтрите',
      clearAll: 'Изчисти всички',
      clearAllAriaLabel: 'Изчисти всички филтри за пазарни аномалии',
      removeFilterAriaLabel: 'Премахни филтър {name}',
      emptyFilteredTitle: 'Няма резултати с тези филтри',
      emptyFilteredDescription: 'Опитайте с по-широки критерии или изчистете активните филтри.',
      // v1.1
      panelToggle: 'Филтри',
      panelToggleShow: 'Покажи филтри',
      panelToggleHide: 'Скрий филтри',
      panelAriaLabel: 'Допълнителни филтри за пазарни аномалии',
      championshipsLabel: 'Първенства',
      championshipsSelectAll: 'Избери всички',
      championshipsDeselectAll: 'Премахни всички',
      championshipsSearchPlaceholder: 'Търси първенство...',
      championshipsAriaLabel: 'Филтър по първенство',
      championshipsNone: 'Първенства: 0',
      marketsLabel: 'Тип пазар',
      marketsSelectAll: 'Избери всички',
      marketsDeselectAll: 'Премахни всички',
      marketsAriaLabel: 'Филтър по тип пазар',
      marketsNone: 'Пазари: 0',
      timeWindowLabel: 'Времеви прозорец',
      timeWindowAll: 'Всички',
      timeWindowToday: 'Днес',
      timeWindowNext24h: 'Следващите 24ч',
      timeWindowNext48h: 'Следващите 48 часа',
      timeWindowAriaLabel: 'Филтър по време на мача',
      timeWindowAllAriaLabel: 'Покажи аномалии без филтър по време',
    },
  },
};

export default bg;


